import EditIcon from '@material-ui/icons/Edit';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from 'react-redux';
import moment, { Moment, MomentInput } from 'moment';
import { change, Field, InjectedFormProps, reduxForm, untouch, stopSubmit } from 'redux-form';
import { API_FAILURE, API_SUCCESS, DEFAULT_DROPDOWN_NAME, DEFAULT_DROPDOWN_VALUE, DEFAULT_MAX_DATE, DEFAULT_MIN_DATE, INVALID_DATE, HttpResponse } from '../../../common/constants/ApiConstants';
import AccordionComponent from "../../../common/formFields/Accordion";
import IconWithButton from "../../../common/IconWithButton/IconWithButton";
import ReduxFormcheckboxField from "../../../common/reduxFormFields/ReduxFormCheckboxField";
import ReduxFormDateField from "../../../common/reduxFormFields/ReduxFormDateField";
import ReduxFormDropdownField, { ReduxDropdownProps } from "../../../common/reduxFormFields/ReduxFormDropDownField";
import ReduxFormRadioField from "../../../common/reduxFormFields/ReduxFormRadioField";
import ReduxFormTextField from "../../../common/reduxFormFields/ReduxFormTextField";
import ReduxFormValidationError from '../../../common/reduxFormFields/ReduxFormValidationError';
import CustomTable from "../../../common/table/CustomTable";
import CompleteTransactionPopUp, { CompleteTransactionWaiting } from "../../../common/alertPopup/CompleteTransactionPopUp";
import CompleteReviewPopUp from "../../../common/alertPopup/CompleteReviewPopUp";
import QAPDIssuePopUp from "../../../common/modal/QAPDIssuesExistsModel";
import DuplicateTXPopup from "../../../common/alertPopup/DuplicateTXPopup";
import { SensitiveInfoUpdate } from "../dataEntryComponents/SensitiveInfo";
import SensitiveInfoField, { applySensitiveInfoUpdate } from "../dataEntryComponents/SensitiveInfoField";
import RecordsRequestedField from "../dataEntryComponents/RecordsRequestedField";
import MultilineTextboxButtons from '../../../common/formFields/MultilineTextboxButtons';

import {
    generatePickerOptions, isValid,
    normalizeData,
    pickerHelperFunction,
    mirrorData,
    generateUpdateBillToRequestorObject,
    generateSendToRequestorObject,
    generateUpdateDisclosureInformationObject,
    getMomentDate,
    _,
    generateSendToRequestorContactObject
} from "../../../common/utils/appUtils";
import "../DataEntryDetails.scss";
import { tabItems } from "../DataEntryTabConstants";
import { BillingFormconstants, FormConstants, RequestorFormConstants } from './DataEntryFieldsConstants';
import localValidations, { ignoreFields, isAuthDateRequired, isDateNotSqlOverflow, infoToReleaseValidiation, isSensitiveInfoSelected } from './validations/localValidations';
import submitValidations from './validations/submitValidations';
import {
    updateBillToRequestorDetailsRequest,
    sendToRequestorDataProps,
    getRequestorSearchDetailsActionCreator,
    patchSendToRequestorContactActionCreators,
    updateBillingPaneFields,
    getPatientSearchDetailsActionCreator,
    createPatientRecordRequest,
    updateFormSyncErrorsActionCreator,
    updateDisclosureInformationActionCreator,
    completeTransactionTaskActionCreator,
    createPatientRecordSuccess,
    billToRequestorDetailsActionCreator,
    nextTransactionIdActionCreator,
    requestorCompleteActionCreator,
    billingCompleteActionCreator, detailsCompleteActionCreator,
    patchPatientDetailsCreator,
    getAuditTypesRequest,
    getOBOsRequest,
    getValidateRequest,
    checkDuplicateTransactions,
    setLastUsedRequestorInfo,
    clearPreviousTransactionOnCompleteCreator,
    readBarCodeDDSRequest,
    getTransactionAttributesActionCreator,
    putDigitalFaxValidationCreator,
    putAuditTransactionSensitiveInfoCreator,
    resetRequestorContactList,
    getReleaseMethodOptionsData,
    setConfirmFaxNumberAction, returnToQueueTaskActionCreator,
    getQAPDIssuesActionCreator,
    setCertificationTemplateAction,
    updateInformationToReleaseActionCreator,
    updateSensitiveInfoActionCreator,
    setRequestorDetailsActionCreator,
    createSendToContactActionCreator,
    updateSendToContactActionCreator,
    setSendToContactActionCreator,
} from "../DataEntryDetailsDucks";
import { createTransaction, clearUserLocksActionRequest, resetRequestContext, getNextQATransaction, lateValidation } from '../../landingPage/LandingPageDucks';
import { ProceedIcon } from '../../../assets/images/proceedIcon';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { AUDIT, DISABILITY_OR_SOCIAL_SECURITY, DISCLOSURE_ACCOUNTING, DISCLOSURE_EVENT, INTERNAL, RequestPurposeUpdate, RequestType } from "../../../models/requestType";
import FeeScheduleInvalidated, { FeeScheduleInvalidatedProps } from "../../../common/modal/FeeScheduleInvalidated";
import FeeSchedule from "../../../models/feeSchedule";
import { ApiUrl } from "../../../services/Network";
import DropdownField, { DropdownOption } from "../../../common/formFields/DropdownField";
import { ReleaseInfoUpdate, TransactionDetails, SensitiveInfoUpdateAPI } from "../../../models/transaction";
import { NewSendToContact, NewSendToRequestor, Requestor, SendToContactUpdate, SendToRequestorUpdate } from '../../../models/requestor';
import { Contact, NameIdPair, UNITED_STATES } from '../../../models/misc';
import DateField from "../../../common/formFields/DateField";
import {determineReleaseMethod} from "./releaseMethodUtils";
import RequestTypePurposeField from "./RequestTypePurposeField";
import AuthorizationDateField from "./AuthorizationDateField";
import RequestDateField from "./RequestDateField";
import CaseNumberField from "./CaseNumberField";
import ClinicResponsibleField from "./ClinicResponsibleField";
import DataEntryDetailsRightPaneBillingSection from "./DataEntryDetailsRightPaneBillingSection";
import DataEntryDetailsRightPaneRequestorSection from "./DataEntryDetailsRightPaneRequestorSection";

interface IpropType {
    activeTabId: number;
    onChangeDataEntryTab: Function;
    proceedBtnClick: boolean;
    dispatch?: Function,
    requestTypes?: readonly RequestType[],
    createPatientRecordSuccess?: Function,
    formState?: any,
    selectedPurposeFromAPI?: number,
    discloseInstitutions?: any,
    transactionDetails: TransactionDetails,
    requestorContactDetails?: readonly Contact[],
    feeSchedules?: FeeSchedule[],
    releaseMethods?: readonly NameIdPair<number>[],
    shippingServices?: any,
    updateBillToRequestorData?: (data: any) => void,
    patchSendToRequestorContactData?: (contact?: any) => void,
    requestorSearchDetails?: any[],
    patientSearchDetails?: any[],
    globalUser?: number
    transactionId?: string,
    updateBillingPaneFields?: (data: any, updateData?: boolean) => void,
    retrieveProtocol: any,
    getPatientListSearchDetails?: (organizationId: number, lastName: string, dob: string) => void,
    phiCodes?: any,
    createPatientRecordRequest?: Function,
    updateFormSyncErrors?: Function,
    formSyncErrors?: any,
    updateDisclosureInformationDetails?: any,
    touch?: any,
    completeTransaction?: any,
    returnToQueue?: any,
    getPatientSearchResultsAPIStatus?: any,
    getRequestorSearchDetailsAPIStatus?: any,
    getContactSearchDetailsAPIStatus?: any,
    getBillToRequestorDetails?: Function,
    /**
     * Facility from which the transaction was opened.
     * Could be the organization ID of the transaction, or the parent org.
     */
    facilityId?: number,
    /**
     * Organization ID of the open transaction.
     */
    organizationId?: number,
    getNextTransactionId?: (facilityId: number, context: number) => void,
    selectedPHICodes?: any,
    patchDetailsComplete?: Function,
    patchRequestorComplete?: Function,
    patchBillingComplete?: Function,
    additionalChargeRecords?: any,
    canEditPatient?: boolean,
    updatedPatientDetailsAttributes?: any,
    patchPatientDetailsCreator?: Function,
    patientDetailsUpdated?: false,
    getAuditTypesRequest?: Function,
    getOBOsRequest?: Function,
    auditTypes?: any,
    onBehalfOf?: any,
    getFacilityFeeSchedules: (organizationId: number, transactionId: string) => void,
    getFacilityShippingServices: Function,
    getFacilityReleaseMethods: (facilityId: number, transactionId: string) => void,
    validationPassed?: boolean,
    checkValidation?: Function,
    checkDuplicates?: Function,
    previousRequestor?: (requestorInfo: any) => void,
    setLastUsedRequestorInfo?: any,
    transactionIDAttributes?: any,
    lastUsedRequestorContact?: any,
    requestorDetails?: Requestor,
    createTransaction?: (data: { facilityId: number }) => void,
    clearUserLocks?: Function,
    clearPreviousTransactionOnComplete?: Function,
    transactionDDS?: any,
    readBarCodeDDSRequest?: Function,
    documentsList?: any,
    updateRequestorDetails?: (requestor?: Requestor) => void,
    intiaTxlSagaCallCount?: any,
    isNewTransaction?: boolean,
    facilityAdditionalFields?: any,
    saveInformationToRelease?: (data: ReleaseInfoUpdate) => void,
    saveAndUpdateSensitiveInfo?: (data: SensitiveInfoUpdateAPI) => void,
    requestContext?: any,
    resetRequestContext?: Function,
    updateDeliveryInstructionsStatus?: any,
    getTransactionAttributes?: (transactionId: string) => void,
    putDigitalFaxValidation?: Function,
    putAuditTransactionSensitiveInfo?: Function,
    transactionStatus?: any,
    readBarCodeDDSAPIStatus?: any,
    resetRequestorContactList?: () => void,
    requestorComplete?: boolean,
    userHasMadeChanged: Function,
    setConfirmFaxNumberAction?: Function,
    /**
     * QA PD Issues fetch/data (unrelated to Quick Entry / Spec #34098) - still
     * live: fetched on validationPassed (AC-independent existing behavior) and
     * rendered via QAPDIssuePopUp below. NOT dead - do not remove; this
     * component is Redux-connected to its own mapStateToProps/mapDispatchToProps
     * for these two (see below), independent of DataEntryDetails.tsx's props.
     */
    getQAPDIssues?: any,
    qaPDIssues?: any,
    getNextQATransactionCall?: Function,
    qaIssues?: Array<any>,
    getCertificationTypes?: Function,
    certificationTypes?: any,
    setCertificationTemplate?: Function,
    certificationTypeId?: string,
    featureFlags?: any,
    createSendToContact?: (contact: NewSendToContact) => void,
    /**
     * Makes an API call to update the send-to contact.
     */
    updateSendToContact?: (organizationId: number, requestBufferId: number, contact: Contact) => void,
    /**
     * Updates the send-to contact in the state without making any API calls.
     */
    setSendToContact?: (contact?: Contact) => void,
    lateValidationCall?: Function,
}

interface InormalizedType {
    [key: string]: any;
}

enum InputFieldLength {
    NAME_MAX_LENGTH = 40,
    MEDICAL_RECORD_NUMBER_MAX_LENGTH = 30,
    REQUEST_ID_MAX_LENGTH = 30,
    EMPI_MAX_LENGTH = 30,
    CASE_NUMBER_MAX_LENGTH = 40,
}
enum TypeOfRequestorID {
    INTERNAL = 5005
}
// call for requestor search
const DataEntryDetailsRightPane: React.FC<IpropType & InjectedFormProps<{}, IpropType>> = (props: IpropType) => {

    function fetchAllSearchRecords(organizationId: number) {
        const phoneOrFax = values[RequestorFormConstants.PHONE_FAX_NUMBER];
        const emailAddress = values[RequestorFormConstants.EMAIL_ADDRESS];
        const address = values[RequestorFormConstants.SEARCH_ADDRESS];
        const zip = values[RequestorFormConstants.SEARCH_ZIP];
        const rqSiteCode = requestType == DISABILITY_OR_SOCIAL_SECURITY ? values[RequestorFormConstants.RQ_SITE_CODE] : "";
        const internalRequestor = props.transactionDetails.transactionRequest?.isInternalRequest && searchName ? searchName : '';
        const typeOfRequestorID = props.transactionDetails.transactionRequest?.isInternalRequest ? TypeOfRequestorID.INTERNAL : null;
        const globalUserId = props.globalUser
        const requestorName = values[RequestorFormConstants.SEARCH_REQUESTOR_NAME];
        const contactName = values[RequestorFormConstants.SEARCH_CONTACT_NAME];

        props.dispatch?.(getRequestorSearchDetailsActionCreator({ phoneOrFax, emailAddress, address, zip, rqSiteCode, internalRequestor, typeOfRequestorID, requestorName, contactName }, organizationId, globalUserId ?? 0));
    }

    const onChangeFaxOrPhoneOrEmail = (value: string) => {
        if (value.length) {
            setErrorMessage("");
        }
        setSearchPhone(value)
    }

    const onClickSearch = () => {
        if (requestType == DISABILITY_OR_SOCIAL_SECURITY) {
            fetchAllSearchRecords(props.organizationId!);
            setRequestorGrid(!showRequestorGrid);
            setShowAddNewRequestor(false);
        } else if (props.transactionDetails.transactionRequest?.isInternalRequest) {
            fetchAllSearchRecords(props.organizationId!);
            setRequestorGrid(!showRequestorGrid);
            setShowAddNewRequestor(false);
        } else {
            //advanceSearchCounter checks if any of the following search fields are empty
            let advanceSearchCounter = 0;
            advanceSearchCounter = values[RequestorFormConstants.SEARCH_ADDRESS] ? advanceSearchCounter + 0 : advanceSearchCounter + 1;
            advanceSearchCounter = values[RequestorFormConstants.SEARCH_ZIP] ? advanceSearchCounter + 0 : advanceSearchCounter + 1;
            advanceSearchCounter = values[RequestorFormConstants.SEARCH_CONTACT_NAME] ? advanceSearchCounter + 0 : advanceSearchCounter + 1;
            advanceSearchCounter = values[RequestorFormConstants.SEARCH_REQUESTOR_NAME] ? advanceSearchCounter + 0 : advanceSearchCounter + 1;

            if (advanceSearchCounter > 2 && showAdvanceRequestorSearch) {
                setErrorMessage("At least two values are required to search.")
            } else if (isValid(values[RequestorFormConstants.PHONE_FAX_NUMBER]).display_error && isValid(values[RequestorFormConstants.EMAIL_ADDRESS]).display_error && !showAdvanceRequestorSearch) {
                setErrorMessage("At least one value is required to search.")
            } else {
                fetchAllSearchRecords(props.organizationId!);
                setRequestorGrid(!showRequestorGrid);
            }
            setShowAddNewRequestor(true);
        }
    }

    const futureDate = new Date();

    const onClickPatientSerach = () => {
        if (isValid(values[FormConstants.SEARCH_LAST_NAME]).display_error) {
            setLastNameError('Last Name or MRN is required.');
        }
        if (isValid(values[FormConstants.SEARCH_DOB]).display_error) {
            setDOBError("DOB is required.")
        }
        const searchDOB = values[FormConstants.SEARCH_DOB]
        let isValidDob = true
        if (searchDOB === INVALID_DATE || (searchDOB && typeof searchDOB === "object" && isNaN(searchDOB.getTime()))) {
            isValidDob = false
        } else if (searchDOB.getTime && searchDOB.getTime() > futureDate.getTime()) {
            isValidDob = false
        } else if (searchDOB.getTime && searchDOB.getTime() < patientMinDOB.getTime()) {
            isValidDob = false
        }
        if (!isValid(values[FormConstants.SEARCH_LAST_NAME]).display_error && !isValid(searchDOB).display_error && isValidDob) {
            setPatientGrid(true)
            setDatePickerSelection("");
            let lastName = values[FormConstants.SEARCH_LAST_NAME];
            let dob = moment(new Date(values[FormConstants.SEARCH_DOB])).format("MM/DD/YYYY")
            props.getPatientListSearchDetails?.(props.organizationId!, lastName, dob);
        }
    }

    const headCellsRequestor = [
        { id: 'comments', label: '', commentField: true },
        { id: 'en', label: 'E/N' },
        { id: 'requestorName', label: 'REQUESTOR NAME' },
        { id: 'address', label: 'Address' },
        { id: 'city', label: 'City' },
        { id: 'state', label: 'State' },
        { id: 'zip', label: 'Zip' },
    ] as const;

    const headCellsContact = [
        { id: 'firstName', label: 'FIRST NAME' },
        { id: 'lastName', label: 'LAST NAME' },
        { id: 'phone', label: 'PHONE' },
        { id: 'fax', label: 'FAX' },
        { id: 'email', label: 'EMAIL' },
    ] as const;

    const headCellsPatient = [
        { id: 'firstName', label: 'FIRST NAME' },
        { id: 'lastName', label: 'LAST NAME' },
        { id: 'dob', label: 'DOB' },
        { id: 'empi', label: 'EMPI' },
    ] as const;

    const normalizedTabItems: InormalizedType = normalizeData(tabItems, "id");
    const [errorMessage, setErrorMessage] = useState("");
    const [isDisableField, setDisableField] = useState(true);
    const [requestorFieldEnabled, setRequestorFieldEnabled] = useState(false);
    const [selectedPatientId, setSelectedPatientId] = useState(0);

    const history = useHistory();

    const setAdditionalChargesErr = (errMsg?: string) => props.updateFormSyncErrors && props.updateFormSyncErrors({ [BillingFormconstants.ADDITIONAL_CHARGES]: !_.isNil(errMsg) ? errMsg : "Required" })
    const [showRequestorGrid, setRequestorGrid] = useState(false);
    const [showContactGrid, setContactGrid] = useState(false);
    const [showPatientGrid, setPatientGrid] = useState(false);

    const [scrollTo, setScrollTo] = useState("");
    const { activeTabId, onChangeDataEntryTab } = props;

    const values = props.formState.values ?? {};

    const [addNewContact, setAddNewContact] = useState(false);
    const [addNewPatient, setAddNewPatient] = useState(false);
    const [lastNameError, setLastNameError] = useState("");
    const [DOBError, setDOBError] = useState("");
    const [showCompleteTransactionPopUp, setCompleteTransactionPopUp] = useState(false);
    const [showCompleteReviewPopUp, setShowCompleteReviewPopUp] = useState(false);
    const [showQAPDIssuePopUp, setShowQAPDIssuePopUp] = useState(false);
    const [wait, setWait] = useState(false)
    const [createNewTransactionComplete, setCreateNewTransactionComplete] = useState(false)
    const [closeTransactionComplete, setCloseNewTransactionComplete] = useState(false)

    const [searchPhone, setSearchPhone] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [searchName, setSearchName] = useState('');
    const [auditTypesOptions, setAuditTypesOptions] = useState([] as any[]);
    const [onBehalfOfOptions, setOnBehalfOfOptions] = useState([] as any[]);

    const [requestType, setRequestType] = useState<number>(props.transactionDetails.requestPurpose?.typeID ?? 0);
    const [requestPurpose, setRequestPurpose] = useState<number>(props.transactionDetails.requestPurpose?.id ?? 0);

    const [feeScheduleId, setFeeScheduleId] = useState<number>(props.transactionDetails.feeSchedule?.id ?? 0);

    const [invalidatedFeeSchedules, setInvalidatedFeeSchedules] = useState<FeeScheduleInvalidatedProps>();

    const billingAdditionalChargeValue = values[BillingFormconstants.ADDITIONAL_CHARGES]

    const [enableEditReqContact, setEnableEditReqContact] = useState(false);

    const [requiredContactError, setRequiredContactError] = useState("");

    const additionalCharges = values[BillingFormconstants.ADDITIONAL_CHARGES];
    const [showAdvanceRequestorSearch, setShowAdvanceRequestorSearch] = useState(false)

    //dds field error messages
    const [docTypeErrorMessage, setDocTypedErrorMessage] = useState("");
    const [rfErrorMessage, setRfErrorMessage] = useState("");
    const [drErrorMessage, setDrErrorMessage] = useState("");
    const [isDisableDDSField, setDisableDDSField] = useState(false);
    const [showAddNewRequestor, setShowAddNewRequestor] = useState(true);
    const [disableFeeScheduleDropDown, setDisableFeeScheduleDropdown] = useState(false);
    const [disableRealeaseMethodDropDown, setDisableRealeaseMethodDropdown] = useState(false);
    const [disableShippingDropDown, setDisableShippingDropdown] = useState(false);

    const [showDigitalFax, setShowDisgitalFax] = useState(props.transactionDetails.releaseMethod?.id === 3);

    const contactsLoaded = props.requestorContactDetails != undefined;
    const [disableRemoveCertification, setDisableRemoveCertification] = useState(true);

    const [datePickerSelection, setDatePickerSelection] = useState("");

    const isVisibleSensitiveInfoToRelease = Boolean(props.transactionDetails.requestPurpose?.id && requestType !== DISCLOSURE_ACCOUNTING);

    useEffect(() => {
        if (props.auditTypes.length === 0) {
            props.getAuditTypesRequest && props.getAuditTypesRequest();
        } else {
            const ato = pickerHelperFunction(props.auditTypes, "titleText", "auditTypeID");
            ato.unshift({ value: DEFAULT_DROPDOWN_VALUE, label: DEFAULT_DROPDOWN_NAME })
            setAuditTypesOptions(ato);
        }
    }, [props.auditTypes]);

    useEffect(() => {
        if (props.onBehalfOf.length === 0) {
            props.getOBOsRequest && props.getOBOsRequest();
        } else {
            const oboo = pickerHelperFunction(props.onBehalfOf, "titleText", "oboid");
            oboo.unshift({ value: DEFAULT_DROPDOWN_VALUE, label: DEFAULT_DROPDOWN_NAME })
            setOnBehalfOfOptions(oboo);
        }
    }, [props.onBehalfOf]);

    useEffect(() => {
        if (props.selectedPHICodes.length) {
            let obj = {};
            if (props.selectedPHICodes) {
                props.selectedPHICodes.map(PHIData => {
                    if (PHIData.isRetrieved) {
                        obj = { ...obj, [PHIData.requestedItemID]: { code: PHIData.code, description: PHIData.description } }
                    }
                    return null
                })
            }
            changeFieldValue(FormConstants.PHI, obj)
        }
    }, [props.selectedPHICodes])

    useEffect(() => {
        setRequestPurpose(props.transactionDetails.requestPurpose?.id ?? 0);
        setRequestType(props.transactionDetails.requestPurpose?.typeID ?? 0);
    }, [props.transactionDetails.requestPurpose?.id]);

    // Billing-tab-scoped effects (additional charges / fee schedule / release
    // method / shipping service sync, internal-request dropdown disabling,
    // delivery-instructions toast, certification-template disable) now live
    // in DataEntryDetailsRightPaneBillingSection (Spec #34098 / F1a, AC13).
    // Requestor-tab-scoped effects (canEditPatient disable, SSN masking,
    // lastUsedRequestorInfo sync, RQID/DDS/barcode sync, NO_BARCODE ->
    // disableDDSField) now live in DataEntryDetailsRightPaneRequestorSection.
    // Both are rendered unconditionally below, alongside this orchestrator's
    // remaining cross-cutting effects.

    useEffect(() => {
        setErrorMessage("")
        setDOBError("")
        setLastNameError("")
        if (activeTabId === 3) {
            props.checkDuplicates && props.checkDuplicates(props.transactionId, values[FormConstants.CASE_NUMBER])
        }
        if (activeTabId !== 1) {
            setEnableEditReqContact(false)
        }
    }, [activeTabId])

    useEffect(() => {
        if (props.validationPassed) {
            if ((props.transactionStatus?.id >= 130 && props.transactionStatus?.id <= 141 && props.transactionStatus?.id != 140) || props.transactionStatus?.id === 122) {
                props.getQAPDIssues(props.transactionId);
                const coIssuesExist = props.qaIssues?.some((issue: any) => (issue.qaErrorTypeName == "CO" || issue.qaErrorTypeName == "QC") && issue.active && !issue.resolved);
                if (!coIssuesExist && props.qaPDIssues?.length) {
                    setShowQAPDIssuePopUp(true);
                } else {
                    if (props.transactionStatus.id == 122) { // FAR should show the complete transaction pop up if no issues are remaining
                        setCompleteTransactionPopUp(true);
                    } else {
                        setShowCompleteReviewPopUp(true);
                    }
                }
            } else {
                setCompleteTransactionPopUp(true);
            }
        } else {
            setCompleteTransactionPopUp(false);
            setShowCompleteReviewPopUp(false);
            setShowQAPDIssuePopUp(false);
        }
    }, [props.validationPassed])

    useEffect(() => {
        if (scrollTo) {
            setTimeout(() => {
                const element = document.getElementById(scrollTo);
                element?.scrollIntoView(true);
                setScrollTo("");
            });
        }
    }, [props.activeTabId])

    const onCheck = (value: boolean) => {
        if (value) {
            const requestorName = values[RequestorFormConstants.REQUESTOR_NAME]
            const address1 = values[RequestorFormConstants.ADDRESS],
                city = values[RequestorFormConstants.CITY],
                state = values[RequestorFormConstants.STATE],
                zip = values[RequestorFormConstants.ZIP],
                email = values[RequestorFormConstants.EMAIL],
                phone = values[RequestorFormConstants.PHONE_NUMBER],
                fax = values[RequestorFormConstants.FAX_NUMBER],
                updatedValues = {
                    [BillingFormconstants.BILL_TO_REQUESTOR_NAME]: requestorName,
                    [BillingFormconstants.BILL_TO_ADDRESS_LINE1]: address1,
                    [BillingFormconstants.BILL_TO_STATE]: state,
                    [BillingFormconstants.BILL_TO_ZIP]: zip,
                    [BillingFormconstants.BILL_TO_CITY]: city,
                    [BillingFormconstants.BILL_TO_FIRST_NAME]: values[RequestorFormConstants.FIRST_NAME] ? values[RequestorFormConstants.FIRST_NAME] : null,
                    [BillingFormconstants.BILL_TO_LAST_NAME]: values[RequestorFormConstants.LAST_NAME] ? values[RequestorFormConstants.LAST_NAME] : null,
                    [BillingFormconstants.BILL_TO_ADDRESS_LINE2]: values[RequestorFormConstants.ADDRESS2],
                    [BillingFormconstants.BILL_TO_EMAIL_ADDRESS]: email ? email : null,
                    [BillingFormconstants.BILL_TO_FAX]: fax ? fax : null,
                    [BillingFormconstants.BILL_TO_PHONE]: phone ? phone : null,
                    [BillingFormconstants.REQUIRES_PREPAYMENT]: values[BillingFormconstants.REQUIRES_PREPAYMENT],
                    requestorNameId: props.requestorDetails?.requestorID
                }
            changeFieldValue(BillingFormconstants.BILL_TO_REQUESTOR_NAME, requestorName)
            changeFieldValue(BillingFormconstants.BILL_TO_FIRST_NAME, values[RequestorFormConstants.FIRST_NAME])
            changeFieldValue(BillingFormconstants.BILL_TO_LAST_NAME, values[RequestorFormConstants.LAST_NAME])
            changeFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE1, address1)
            changeFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE2, values[RequestorFormConstants.ADDRESS2])
            changeFieldValue(BillingFormconstants.BILL_TO_CITY, city)
            changeFieldValue(BillingFormconstants.BILL_TO_STATE, state)
            changeFieldValue(BillingFormconstants.BILL_TO_EMAIL_ADDRESS, values[RequestorFormConstants.EMAIL])
            changeFieldValue(BillingFormconstants.BILL_TO_FAX, values[RequestorFormConstants.FAX_NUMBER])
            changeFieldValue(BillingFormconstants.BILL_TO_PHONE, values[RequestorFormConstants.PHONE_NUMBER])
            changeFieldValue(BillingFormconstants.BILL_TO_ZIP, zip)
            if (requestorName?.length && address1?.length && city?.length && state?.length && zip?.length) {
                /* Make api call */
                let data = {
                    requestorbillingcontactid: props.transactionDetails.billToContact?.id || null,
                    transactionId: props.transactionId,
                    data: generateUpdateBillToRequestorObject(updatedValues)
                }
                props.updateBillToRequestorData!(data)
            }
        }
        else {
            changeFieldValue(BillingFormconstants.BILL_TO_REQUESTOR_NAME, '')
            changeFieldValue(BillingFormconstants.BILL_TO_FIRST_NAME, '')
            changeFieldValue(BillingFormconstants.BILL_TO_LAST_NAME, '')
            changeFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE1, '')
            changeFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE2, '')
            changeFieldValue(BillingFormconstants.BILL_TO_CITY, '')
            changeFieldValue(BillingFormconstants.BILL_TO_STATE, '')
            changeFieldValue(BillingFormconstants.BILL_TO_EMAIL_ADDRESS, '')
            changeFieldValue(BillingFormconstants.BILL_TO_FAX, '')
            changeFieldValue(BillingFormconstants.BILL_TO_PHONE, '')
            changeFieldValue(BillingFormconstants.BILL_TO_ZIP, '')
        }
    }

    const goToNextTransaction = () => {
        if (props.requestContext == 8) {
            props.getNextQATransactionCall?.();
        } else {
            props.getNextTransactionId?.(props.facilityId!, props.requestContext ?? 1);
        }
    };

    const runLateValidation = () => {
        // infoReleaseInitialLoad now lives inside RecordsRequestedField's own
        // local state (Spec #34098 / F1a extraction) - this used to force
        // that field's errors to reveal immediately on a late-validation
        // attempt (e.g. tab-switch) even before the user touched it
        // directly; that specific early-reveal nicety no longer applies here
        // (resultsITR.display_error below still blocks submission correctly,
        // this only affects when the inline error styling first appears).
        let validPass = true;
        if (isVisibleSensitiveInfoToRelease) {

            let resultsSI = isSensitiveInfoSelected(props.transactionDetails.sensitiveInfo);
            let resultsITR = infoToReleaseValidiation(props.transactionDetails.releaseInfo);

            if (resultsSI.display_error || resultsITR.display_error) {
                let outMessage = ["Under the Details tab: "];
                resultsSI.error_msg && outMessage.push(resultsSI.error_msg);
                resultsITR.errors.from && outMessage.push(resultsITR.errors.from);
                resultsITR.errors.to && outMessage.push(resultsITR.errors.to);
                resultsITR.errors.items && outMessage.push(resultsITR.errors.items);

                props.formSyncErrors[FormConstants.SENSITIVE_INFORMATION] = resultsSI.error_msg;
                props.lateValidationCall?.(outMessage);
                validPass = false;
            } else {
                props.formSyncErrors[FormConstants.SENSITIVE_INFORMATION] = null;
            }
        }
        else { props.formSyncErrors[FormConstants.SENSITIVE_INFORMATION] = null; }

        return validPass;
    }

    const goToNextQATransaction = () => {
        if (props.requestContext == 6 || props.requestContext == 7 || props.requestContext == 8) {
            goToNextTransaction();
        } else {
            setCloseNewTransactionComplete(false)
            history?.push("/home")
        }
    };

    const createNewRequestor = async (requestData: NewSendToRequestor) => {
        const response = await fetch(
            `${ApiUrl()}requestor/createSendTo?userId=${global.userID}`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            },
        );
        if (response.status < 400) {
            setInvalidatedFeeSchedules(undefined);
            props.getFacilityFeeSchedules(props.organizationId!, props.transactionId!);
            props.getTransactionAttributes!(props.transactionId!);
        } else if (response.status == HttpResponse.Conflict) {
            setInvalidatedFeeSchedules({
                confirm: () => createNewRequestor({ ...requestData, clearFeeOk: true }),
                close: () => {
                    props.getTransactionAttributes!(props.transactionId!);
                    setInvalidatedFeeSchedules(undefined);
                },
                invalidatingProperty: "requestor",
                invalidatingValue: requestData.name,
                feeScheduleNames: (await response.json() as NameIdPair<number>[]).map(x => x.name),
            });
        }
    }

    const onBlurRequestorTabFields = (value: string, fieldName: string, _event: React.FocusEvent) => {
        if (value.length < 1 && fieldName !== RequestorFormConstants.FAX_NUMBER) {
            return;
        }

        const requestorName = values[RequestorFormConstants.REQUESTOR_NAME]
        const address1 = values[RequestorFormConstants.ADDRESS]
        const city = values[RequestorFormConstants.CITY]
        const state = values[RequestorFormConstants.STATE]
        const zip = values[RequestorFormConstants.ZIP]
        const firstName = values[RequestorFormConstants.FIRST_NAME]
        const lastName = values[RequestorFormConstants.LAST_NAME]
        const phone = values[RequestorFormConstants.PHONE_NUMBER]
        const email = values[RequestorFormConstants.EMAIL];
        const fax = values[RequestorFormConstants.FAX_NUMBER]

        if (requestorName && address1 && city && state && zip) {
            if (requestorFieldEnabled) {
                let data = generateSendToRequestorObject(values, props.organizationId!, props.transactionDetails.id);
                createNewRequestor(data);
                setRequestorFieldEnabled(false)
            } else if (firstName || lastName || phone || fax || email) {
                if (addNewContact) {
                    const data: NewSendToContact = {
                        organizationId: props.transactionDetails.facility.id,
                        requestBufferId: props.transactionDetails.id,
                        sendToRequestor: props.requestorDetails!.requestorID,
                        firstName: firstName || null,
                        lastName: lastName || null,
                        phone: phone || null,
                        email: email || null,
                        fax: fax || null,
                    }
                    props.createSendToContact?.(data);
                    setAddNewContact(false);
                } else if (props.requestorDetails?.requestorInfo) {
                    let data = {
                        requestType,
                        data: {
                            ...generateSendToRequestorContactObject(values, props.transactionId),
                            requestType,
                            requestorcontactid: props.requestorDetails.requestorInfo.id,
                        }
                    }
                    props.setSendToContact?.({
                        ...props.requestorDetails.requestorInfo,
                        firstName,
                        lastName,
                        email,
                        phone,
                        fax,
                    });
                    props.patchSendToRequestorContactData?.(data)
                }
            }
        }
    }

    const onBlurDisclosureInformationFields = (value: string, fieldName: string) => {
        let updatedValues = { ...values }
        updatedValues[fieldName] = value
        const disclosureReason = updatedValues[FormConstants.DISCLOSURE_REASON]
        const disclosureDate = updatedValues[FormConstants.DISCLOSURE_DATE]
        const disclosureDateFormatted = new Date(updatedValues[FormConstants.DISCLOSURE_DATE])

        if (disclosureReason && disclosureReason !== DEFAULT_DROPDOWN_VALUE && disclosureDate && disclosureDate !== INVALID_DATE && !isNaN(disclosureDateFormatted.getTime()) && isDateNotSqlOverflow(disclosureDate)) {
            let data = {
                transactionID: props.transactionId,
                data: generateUpdateDisclosureInformationObject(updatedValues)
            }
            props && props.updateDisclosureInformationDetails(data)
        }
    }

    const onBlurBillingPangeFields = (value: string, fieldName: string) => {
        const requestorName = values[BillingFormconstants.BILL_TO_REQUESTOR_NAME]
        const address1 = values[BillingFormconstants.BILL_TO_ADDRESS_LINE1]
        const city = values[BillingFormconstants.BILL_TO_CITY]
        const state = values[BillingFormconstants.BILL_TO_STATE]
        const zip = values[BillingFormconstants.BILL_TO_ZIP]
        let updatedValues = {
            ...values,
            [fieldName]: value,
            requestorNameId: props.requestorDetails?.requestorID,
        }
        if ((requestorName?.length && address1?.length && city?.length && state?.length && zip?.length) ||
            fieldName === BillingFormconstants.REQUIRES_PREPAYMENT || fieldName === BillingFormconstants.DELIVERY_INSTRUCTIONS) {
            /* Make api call */
            let data = {
                requestorbillingcontactid: props.transactionDetails.billToContact?.id || null,
                transactionId: props.transactionId,
                data: generateUpdateBillToRequestorObject(updatedValues)
            }
            if (fieldName === BillingFormconstants.DELIVERY_INSTRUCTIONS) {
                data.data["deliveryInstructions"] = encodeURI(value)
            }
            props.updateBillToRequestorData!(data)
        }
    }

    const changeFieldValue = (fieldName: string, value: any) => {
        if (value === undefined) {
            value = '';
        }
        props.dispatch && props.dispatch({
            type: "@@redux-form/CHANGE", payload: value, meta: {
                field: fieldName,
                touch: true, persistentSubmitErrors: false, form: FormConstants.DATA_ENTRY_FIELDS_FORM
            }
        })
    }

    const onChangeRequestorName = (value: string) => {
        changeFieldValue(BillingFormconstants.SEND_TO_REQUESTOR_NAME, value)
    }

    const onChangeFirstName = (value: string, copyToBilling = false) => {
        changeFieldValue(BillingFormconstants.SEND_TO_FIRST_NAME, value);
        copyToBilling && changeFieldValue(BillingFormconstants.BILL_TO_FIRST_NAME, value);
    }

    const onChangeLastName = (value: string, copyToBilling = false) => {
        changeFieldValue(BillingFormconstants.SEND_TO_LAST_NAME, value)
        copyToBilling && changeFieldValue(BillingFormconstants.BILL_TO_LAST_NAME, value);
    }

    const onChangeAddress1 = (value: string) => {
        changeFieldValue(BillingFormconstants.SEND_TO_ADDRESS_LINE1, value)
    }

    const onChangeAddress2 = (value: string) => {
        changeFieldValue(BillingFormconstants.SEND_TO_ADDRESS_LINE2, value)
    }

    const onChangeCity = (value: string) => {
        changeFieldValue(BillingFormconstants.SEND_TO_CITY, value)
    }

    const onChangeState = (value: string) => {
        changeFieldValue(BillingFormconstants.SEND_TO_STATE, value)
    }

    const onChangeZip = (value: string) => {
        changeFieldValue(BillingFormconstants.SEND_TO_ZIP, value)
    }

    const onChangePhone = (value: string, copyToBilling = false) => {
        changeFieldValue(BillingFormconstants.SEND_TO_PHONE, value)
        copyToBilling && changeFieldValue(BillingFormconstants.BILL_TO_PHONE, value);
    }
    const onChangeFax = (value: string, copyToBilling = false) => {
        changeFieldValue(BillingFormconstants.SEND_TO_FAX, value)
        copyToBilling && changeFieldValue(BillingFormconstants.BILL_TO_FAX, value);
    }
    const onChangeEmail = (value: string, copyToBilling = false) => {
        changeFieldValue(BillingFormconstants.SEND_TO_EMAIL_ADDRESS, value)
        copyToBilling && changeFieldValue(BillingFormconstants.BILL_TO_EMAIL_ADDRESS, value);
    }

    //dds fields
    const onChangeRQID = (value: string) => {
        changeFieldValue(RequestorFormConstants.RQID, value)
    }

    const onBlurRQID = (value: string, _name: string, _event: React.FocusEvent) => {
        if (!values[RequestorFormConstants.NO_BARCODE]) {
            const reqObj = {
                transactionId: props.transactionId,
                userID: global.userID,
                RQID: value
            }
            props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)
        }
    }

    const onChangeRQSiteCode = (value: string) => {
        changeFieldValue(RequestorFormConstants.RQ_SITE_CODE, value)
    }

    const onChangeTXSiteCode = (value: string) => {
        changeFieldValue(RequestorFormConstants.TX_SITE_CODE, value)
    }

    const onBlurTXSiteCode = (value: string, _name: string, _event: React.FocusEvent) => {
        const reqObj = {
            transactionId: props.transactionId,
            userID: global.userID,
            txSiteCode: value,
            rqSiteCode: value

        }
        if (!values[RequestorFormConstants.NO_BARCODE]) {
            props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)
        }
    }

    const onChangeSSN = (value: string) => {
        changeFieldValue(RequestorFormConstants.SSN, value)
    }

    const onBlurSSN = (value: string, _name: string, _event: React.FocusEvent) => {
        if (value.length > 0 && value !== '***-**-***') {
            if (!values[RequestorFormConstants.NO_BARCODE]) {
                const reqObj = {
                    transactionId: props.transactionId,
                    userID: global.userID,
                    ssn: value
                }
                props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)
                maskSSNInput(value);
            }
        }
    }

    const onChangeDocType = (value: string) => {
        if (value.length !== 4) {
            setDocTypedErrorMessage("Doctype must be exactly 4 characters long")
        } else {
            setDocTypedErrorMessage("")
        }
        changeFieldValue(RequestorFormConstants.DOC_TYPE, value)
    }

    const onBlurDocType = (value: string, _name: string, _event: React.FocusEvent) => {
        if (value.length === 4) {
            if (!values[RequestorFormConstants.NO_BARCODE]) {
                const reqObj = {
                    transactionId: props.transactionId,
                    userID: global.userID,
                    docType: value
                }
                props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)
            }
        }
    }

    const onChangeRF = (value: string) => {
        if (!(value.toLowerCase() === "p" || value.toLowerCase() === "d" || value.toLowerCase() === "no rf")) {
            setRfErrorMessage("Routing Field must be either P, D, or No RF")
        } else {
            setRfErrorMessage("")

        }

        changeFieldValue(RequestorFormConstants.ROUTING_FIELD, value)
    }

    const onBlurRF = (value: string, _name: string, _event: React.FocusEvent) => {
        if (value.toLowerCase() === "p" || value.toLowerCase() === "d" || value.toLowerCase() === "no rf") {
            if (!values[RequestorFormConstants.NO_BARCODE]) {
                const reqObj = {
                    transactionId: props.transactionId,
                    userID: global.userID,
                    routingField: value,
                }
                props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)
            }
        }
    }

    const onChangeDR = (value: string) => {
        if (!(value.toLowerCase() === "f" || value.toLowerCase() === "s" || value.toLowerCase() === "no dr")) {
            setDrErrorMessage("DocReturnCode must be either F, S, or No DR");
        } else {
            setDrErrorMessage("")
        }
        changeFieldValue(RequestorFormConstants.DOC_RETURN_CODE, value)
    }

    const onBlurDR = (value: string, _name: string, _event: React.FocusEvent) => {
        if (value.toLowerCase() === "f" || value.toLowerCase() === "s" || value.toLowerCase() === "no dr") {
            if (values[RequestorFormConstants.NO_BARCODE] === undefined || !values[RequestorFormConstants.NO_BARCODE]) {
                const reqObj = {
                    transactionId: props.transactionId,
                    userID: global.userID,
                    docReturnCode: value
                }
                props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)
            }
        }
    }

    const onChangeNoBarcode = (value: boolean, _name: string) => {
        // add blank fields for update
        const reqObj = {
            transactionId: props.transactionId,
            userID: global.userID,
            txSiteCode: "",
            rqSiteCode: "",
            docReturnCode: "",
            routingField: "",
            RQID: "",
            docType: "",
            ssn: "",
            noBarcode: value

        }
        props.updateBillingPaneFields && props.updateBillingPaneFields(reqObj)

        if (value) {
            changeFieldValue(RequestorFormConstants.DOC_RETURN_CODE, "")
            changeFieldValue(RequestorFormConstants.ROUTING_FIELD, "")
            changeFieldValue(RequestorFormConstants.DOC_TYPE, "")
            changeFieldValue(RequestorFormConstants.SSN, "")
            changeFieldValue(RequestorFormConstants.RQID, "")
            changeFieldValue(RequestorFormConstants.TX_SITE_CODE, "")
            changeFieldValue(RequestorFormConstants.RQ_SITE_CODE, "")

            changeFieldValue(BillingFormconstants.RELEASE_METHODS, 5)
            onChangeDetailsOrBillingPaneField(5, BillingFormconstants.RELEASE_METHODS)
        }
        else {
            changeFieldValue(RequestorFormConstants.DOC_TYPE, "0001")
        }
        changeFieldValue(RequestorFormConstants.NO_BARCODE, value)
    }


    const resetFieldValue = (fieldName: string) => {
        props.dispatch && props.dispatch(change(FormConstants.DATA_ENTRY_FIELDS_FORM, fieldName, null))
        props.dispatch && props.dispatch(untouch(FormConstants.DATA_ENTRY_FIELDS_FORM, fieldName))
    }

    // AC11 / Spec #34098 (F1a): the base DATA_ENTRY_FIELDS_FORM writes for
    // Request Type/Purpose now happen inside the shared RequestTypePurposeField
    // component via writeFieldToForm - this handler only runs the remaining,
    // Details-tab-specific cascade side effects (sensitive info reset, PHI
    // reset, barcode DDS trigger).
    const onChangeRequestType = (newType: number) => {
        if (newType == DISCLOSURE_ACCOUNTING) {
            resetFieldValue(FormConstants.PHI)
        } else if (newType == AUDIT) {

            const infoList = props.transactionDetails.sensitiveInfo;
            const infoUpdate = infoList.map(i => ({
                updatedItemId: i.id,
                checked: true,
            } as SensitiveInfoUpdate));

            applySensitiveInfoUpdate(infoList, infoUpdate, props.transactionId, props.dispatch!, props.saveAndUpdateSensitiveInfo);
        }
        setRequestType(newType);
        setRequestPurpose(0);

        let reqDoc = props.documentsList?.filter(el => el.id.includes('REQ'))
        if (reqDoc.length === 1 && newType == DISABILITY_OR_SOCIAL_SECURITY) {
            props.readBarCodeDDSRequest && props.readBarCodeDDSRequest(reqDoc[0].id);
        }
    }

    const updateRequestPurpose = async (newPurpose: number, clearFeeOk?: boolean) => {
        const requestBody: RequestPurposeUpdate = {
            organizationId: props.transactionDetails.facility.id,
            requestBufferId: props.transactionDetails.id,
            requestPurposeId: newPurpose,
            clearFeeOk: clearFeeOk ?? false,
        } as const;

        const response = await fetch(
            `${ApiUrl()}transactions/purpose?userId=${global.userID}`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            },
        );

        if (response.status < 400) {
            setInvalidatedFeeSchedules(undefined);
            props.getFacilityFeeSchedules(props.organizationId!, props.transactionId!);
            props.getTransactionAttributes!(props.transactionId!);
        } else if (response.status == HttpResponse.Conflict) {
            setInvalidatedFeeSchedules({
                confirm: () => updateRequestPurpose(newPurpose, true),
                close: () => {
                    setRequestType(props.transactionDetails.requestPurpose!.typeID);
                    setRequestPurpose(props.transactionDetails.requestPurpose!.id);
                    setInvalidatedFeeSchedules(undefined);
                },
                invalidatingProperty: "request purpose",
                invalidatingValue: props.requestTypes!.find(type => type.id == requestType)!.requestPurpose.find(purp => purp.id == newPurpose)!.name,
                feeScheduleNames: (await response.json() as NameIdPair<number>[]).map(x => x.name),
            });
        }
    }

    // AC11: base form write now handled by RequestTypePurposeField; this
    // handler runs the remaining fee-schedule cascade.
    const onChangeRequestPurpose = (newPurpose: number) => {
        setRequestPurpose(newPurpose);
        if (newPurpose) {
            updateRequestPurpose(newPurpose);
        }
    }

    const onChangeFeeSchedule = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newFeeScheduleId = parseInt(event.target.value);
        setFeeScheduleId(newFeeScheduleId);
        onChangeDetailsOrBillingPaneField(newFeeScheduleId, BillingFormconstants.FEE_SCHEDULES, true);
    }

    const onBtnClick = () => {
        let isValidForm = true
        if (Object.keys(normalizedTabItems).length > activeTabId) {
            if (activeTabId === 3 && additionalCharges && Object.keys(additionalCharges).length) {

                let unfilledColumns = Object.keys(additionalCharges).filter((item: any) => {
                    const rowData = additionalCharges[item]
                    return (isValid(rowData.glCodeID).display_error || rowData.glCodeID === DEFAULT_DROPDOWN_VALUE || isValid(rowData.chargeAmount).display_error || isValid(rowData.description).display_error)
                })
                if (unfilledColumns.length) {
                    setAdditionalChargesErr()
                    isValidForm = false
                }
            }
            let editFormLocalValidations = localValidations(values, props);

            ignoreFields.map(item => delete editFormLocalValidations[item])

            if (values[RequestorFormConstants.REQUESTOR_NAME] &&
                (!values[RequestorFormConstants.FIRST_NAME] &&
                    !values[RequestorFormConstants.LAST_NAME] &&
                    !values[RequestorFormConstants.EMAIL] &&
                    !values[RequestorFormConstants.PHONE_NUMBER] &&
                    !values[RequestorFormConstants.FAX_NUMBER])) {
                setRequiredContactError("A contact selection must be made.");
                props.touch && props.touch(RequestorFormConstants.REQUESTOR_CONTACT);
            } else {
                delete editFormLocalValidations[RequestorFormConstants.REQUESTOR_CONTACT]
            }

            if (isValidForm && !Object.keys(editFormLocalValidations).length) {
                if ((requestType == DISCLOSURE_EVENT && activeTabId === 2) || activeTabId === 4) { return null }

                if (activeTabId === 1) {
                    props.getFacilityFeeSchedules(props.organizationId!, props.transactionId!)
                    props.getFacilityShippingServices(props.organizationId);
                    props.patchDetailsComplete && props.patchDetailsComplete(props.transactionId);
                    document.getElementsByClassName('right-pane')[0].scrollTo(0, 0);
                }
                else if (activeTabId === 2) {
                    const hasETransferSetup = !!props.requestorDetails?.eTransferSetup;
                    const currentContact = props.requestorDetails?.requestorInfo;
                    const defaultReleaseMethod = determineReleaseMethod(
                        hasETransferSetup,
                        currentContact,
                        props.transactionDetails.requestPurpose?.id
                    );

                    changeFieldValue(BillingFormconstants.RELEASE_METHODS,
                        props.transactionDetails.releaseMethod?.id ?? defaultReleaseMethod);
                    props.getFacilityReleaseMethods(props.organizationId!, props.transactionId!);
                    props.patchRequestorComplete && props.patchRequestorComplete(props.transactionId);
                    document.getElementsByClassName('right-pane')[0].scrollTo(0, 0);
                }
                else if (activeTabId === 3) {
                    props.patchBillingComplete && props.patchBillingComplete(props.transactionId);
                }
                onChangeDataEntryTab(activeTabId + 1, false)
            }

            props.touch && props.touch(...Object.keys(editFormLocalValidations))
            props.dispatch && props.dispatch(stopSubmit(FormConstants.DATA_ENTRY_FIELDS_FORM, editFormLocalValidations))
        }

        sessionStorage.setItem("formValues", JSON.stringify(values))
    };

    const onCompleteTransaction = () => {


        props.setLastUsedRequestorInfo({
            requestorName: props.requestorDetails?.fullName,
            address1: props.requestorDetails?.requestorAddress?.address1,
            address2: props.requestorDetails?.requestorAddress?.address2,
            city: props.requestorDetails?.requestorAddress?.city,
            state: props.requestorDetails?.requestorAddress?.state,
            zip: props.requestorDetails?.requestorAddress?.zipCode,
            firstName: props.requestorDetails?.requestorInfo?.firstName,
            lastName: props.requestorDetails?.requestorInfo?.lastName,
            email: props.requestorDetails?.requestorInfo?.email,
            phone: props.requestorDetails?.requestorInfo?.phone,
            fax: props.requestorDetails?.requestorInfo?.fax,
            requestorContactId: props.requestorDetails?.requestorInfo?.id,
            requestorId: props.requestorDetails?.requestorID,
            requestPurpose: props.transactionDetails.requestPurpose,
            org: props.organizationId,
            transactionId: props.transactionId
        });

        let lateValidationsPass = runLateValidation();
        if (lateValidationsPass) {
            props.getQAPDIssues(props.transactionId);
            props?.checkValidation && props.checkValidation(props.transactionId)
        }
    }
    const onCompleteTransactionNewRequest = () => {
        setCreateNewTransactionComplete(true);
        onCompleteTransaction();
    }

    const clearPreviousTransactionOnComplete = () => {
        props.clearPreviousTransactionOnComplete && props.clearPreviousTransactionOnComplete();
    }

    const clearUserLocks = () => {
        props.clearUserLocks && props.clearUserLocks();
    };

    const createTransaction = (data: { facilityId: number }) => {
        props.createTransaction && props.createTransaction(data);
    }

    const onCloseCompleteTransaction = () => {
        setShowCompleteReviewPopUp(false);
        setCloseNewTransactionComplete(true);
        onCompleteTransaction();
    }

    const updateSendToRequestor = async (sendToRequestorId: number, requestorName: string, clearFeeOk: boolean = false) => {
        const requestBody: SendToRequestorUpdate = {
            organizationId: props.organizationId!,
            requestBufferId: props.transactionDetails.id,
            sendToRequestorId: sendToRequestorId,
            clearFeeOk: clearFeeOk,
        };

        const response = await fetch(
            `${ApiUrl()}transactions/sendToRequestor?userId=${global.userID}`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            },
        );

        if (response.status < 400) {
            setSearchPhone("");
            setSearchEmail("");
            setRequestorFieldEnabled(false);
            setInvalidatedFeeSchedules(undefined);
            props.getFacilityFeeSchedules(props.organizationId!, props.transactionId!);
            props.getTransactionAttributes!(props.transactionId!);
        } else if (response.status == HttpResponse.Conflict) {
            setInvalidatedFeeSchedules({
                confirm: () => updateSendToRequestor(sendToRequestorId, requestorName, true),
                close: () => {
                    setInvalidatedFeeSchedules(undefined);
                },
                invalidatingProperty: "requestor",
                invalidatingValue: requestorName,
                feeScheduleNames: (await response.json() as NameIdPair<number>[]).map(x => x.name),
            });
        }
    }

    const onRequestorTableRowClickHandler = (rowData?: any) => {
        resetFieldValue(RequestorFormConstants.PHONE_FAX_NUMBER)
        resetFieldValue(RequestorFormConstants.EMAIL_ADDRESS)
        resetFieldValue(RequestorFormConstants.SEARCH_ADDRESS)
        resetFieldValue(RequestorFormConstants.SEARCH_ZIP)
        resetFieldValue(RequestorFormConstants.SEARCH_REQUESTOR_NAME)
        resetFieldValue(RequestorFormConstants.SEARCH_CONTACT_NAME)
        props.resetRequestorContactList!();
        setRequiredContactError("");
        untouch(RequestorFormConstants.REQUESTOR_CONTACT);
        if (rowData?.requestorId) {
            setTimeout(() => {
                updateSendToRequestor(rowData.requestorId, rowData.requestorName);
            });
        } else {
            resetFieldValue(RequestorFormConstants.REQUESTOR_NAME);
            resetFieldValue(BillingFormconstants.BILL_TO_REQUESTOR_NAME);
            resetFieldValue(RequestorFormConstants.CITY);
            resetFieldValue(BillingFormconstants.BILL_TO_CITY);
            resetFieldValue(RequestorFormConstants.ZIP);
            resetFieldValue(BillingFormconstants.BILL_TO_ZIP);
            resetFieldValue(RequestorFormConstants.STATE);
            resetFieldValue(BillingFormconstants.BILL_TO_STATE);
            resetFieldValue(RequestorFormConstants.ADDRESS);
            resetFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE1);
            resetFieldValue(RequestorFormConstants.ADDRESS);
            resetFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE1);
            resetFieldValue(RequestorFormConstants.ADDRESS2);
            resetFieldValue(BillingFormconstants.BILL_TO_ADDRESS_LINE2);
            resetFieldValue(BillingFormconstants.REQUIRES_PREPAYMENT);
        }
    }

    const isInvalidDate = (date: string) => {
        return date.toUpperCase() === INVALID_DATE.toUpperCase() || date.length === 0
    }

    const isValidDate = (date: string | Date | MomentInput | Moment | null | undefined) => {
        if (!date) return false;
        if (typeof date === 'string') return !isInvalidDate(date);
        if (date instanceof Date) return !isNaN(date.getTime());
        return moment(date).isValid();
    }

    // Pure extraction from the previous single onChangeDetailsOrBillingPaneField
    // body - identical keyName/autosave logic, minus the changeFieldValue write.
    // Used as the onXChange callback for the new shared field components
    // (AuthorizationDateField/RequestDateField/CaseNumberField/
    // ClinicResponsibleField, Spec #34098 / F1a) - those components write the
    // form value themselves via writeFieldToForm, so this path must NOT also
    // dispatch changeFieldValue (same "caller does not duplicate the form
    // write" rule RequestTypePurposeField's onRequestTypeChange/
    // onRequestPurposeChange already established. Every PRE-EXISTING caller
    // keeps going through onChangeDetailsOrBillingPaneField below, unchanged.
    const autosaveBillingPaneField = (value: any, fieldName: string, updateData?: boolean) => {
        let keyName = ""
        let updatedValue = value
        let extraProps = {}

        switch (fieldName) {
            case BillingFormconstants.FEE_SCHEDULES:
                keyName = "feeScheduleId"
                break
            case BillingFormconstants.CERTIFICATION_REQUESTED:
                keyName = "certRequired"
                break
            case BillingFormconstants.CERTIFICATION_TEMPLATE:
                keyName = "certTemplate"
                break
            case BillingFormconstants.CHARGE_FOR_POSTAGE:
                keyName = "postageIsApplied"
                break
            case BillingFormconstants.RELEASE_METHODS:
                keyName = "releaseMethodId"
                break
            case BillingFormconstants.SHIPPING_SERVICES:
                keyName = "shippingService"
                break
            case FormConstants.CLINIC_RESPONISBLE:
                keyName = "clinicdepartmentid"
                break
            case FormConstants.MRN_ID:
                keyName = "mrn"
                break
            case FormConstants.AUTHORIZATION_DATE:
                updatedValue = getMomentDate(value)
                if (!isValidDate(updatedValue) || !isDateNotSqlOverflow(updatedValue)) {
                    return
                }
                keyName = "authdate"
                break
            case FormConstants.REQUEST_DATE:
                updatedValue = getMomentDate(value)
                if (!isValidDate(updatedValue) || !isDateNotSqlOverflow(updatedValue)) {
                    return
                }
                keyName = "requestDate"
                break
            case FormConstants.RECEIVED_DATE:
                updatedValue = getMomentDate(value)
                if (!isValidDate(updatedValue) || !isDateNotSqlOverflow(updatedValue)) {
                    return
                }
                keyName = "receiveddate"
                break
            case FormConstants.DUE_DATE:
                updatedValue = getMomentDate(value)
                if (!isValidDate(updatedValue) || !isDateNotSqlOverflow(updatedValue)) {
                    return
                }
                keyName = "duedate"
                break
            case FormConstants.CASE_NUMBER:
                keyName = "caseNumber"
                break
            case FormConstants.REQUEST_ID:
                keyName = "requestid"
                break
            case "patientDataid":
                keyName = "patientDataid"
                break
            case FormConstants.AUDIT_TYPE:
                keyName = "auditType"
                break
            case FormConstants.ON_BEHALF_OF:
                keyName = "onBehalfOf"
                break
        }
        let patientDataid = selectedPatientId || props.transactionDetails.patient?.id || null
        let billToRequestorContactId = props.transactionDetails.billToContact?.id || null
        if (keyName === "patientDataid") {
            patientDataid = value || null
        }
        if (keyName === "feeScheduleId" && value !== "98") {
            if (billToRequestorContactId) {
                props.getBillToRequestorDetails && props.getBillToRequestorDetails(billToRequestorContactId)
            }
        }
        if (keyName == "certTemplate") {
            if (!value || value == "-9999") {
                if (!window.confirm("Remove certification?")) {
                    return;
                }
            }
            setDisableRemoveCertification(!(value && value != "-9999"));
            props.setCertificationTemplate?.(props.transactionId, value);
            return;
        }
        if (keyName === "releaseMethodId" && value === "2") {
            setDisableShippingDropdown(true);
        }
        else {
            setDisableShippingDropdown(false);
        }
        if (keyName === "releaseMethodId") {
            setShowDisgitalFax(value === "3");
        }
        if (keyName.length) {
            const requestObject = {
                patientDataid: patientDataid || null,
                [keyName]: updatedValue,
                ...extraProps,
                transactionId: props.transactionId,
                userID: global.userID
            }

            props.userHasMadeChanged()
            props.updateBillingPaneFields && props.updateBillingPaneFields(requestObject, updateData)
        }
    }

    // Every pre-existing call site keeps calling this exact name with this
    // exact two-step behavior (changeFieldValue write, then autosave) -
    // unchanged from before the autosaveBillingPaneField extraction above.
    const onChangeDetailsOrBillingPaneField = (value: any, fieldName: string, updateData?: boolean) => {
        changeFieldValue(fieldName, value)
        autosaveBillingPaneField(value, fieldName, updateData)
    }

    const onContactTableRowClickHandler = (rowData?: Contact) => {
        setAddNewContact(false)
        setEnableEditReqContact(false)
        if (rowData?.firstName) {
            changeFieldValue(RequestorFormConstants.FIRST_NAME, rowData.firstName);
            changeFieldValue(BillingFormconstants.BILL_TO_FIRST_NAME, rowData.firstName);
        } else {
            resetFieldValue(RequestorFormConstants.FIRST_NAME);
            resetFieldValue(BillingFormconstants.BILL_TO_FIRST_NAME)
        }
        if (rowData?.lastName) {
            changeFieldValue(RequestorFormConstants.LAST_NAME, rowData.lastName);
            changeFieldValue(BillingFormconstants.BILL_TO_LAST_NAME, rowData.lastName);
        } else {
            resetFieldValue(RequestorFormConstants.LAST_NAME)
            resetFieldValue(BillingFormconstants.BILL_TO_LAST_NAME)
        }
        if (rowData?.email) {
            changeFieldValue(RequestorFormConstants.EMAIL, rowData.email);
            changeFieldValue(BillingFormconstants.BILL_TO_EMAIL_ADDRESS, rowData.email);
        } else {
            resetFieldValue(RequestorFormConstants.EMAIL)
            resetFieldValue(BillingFormconstants.BILL_TO_EMAIL_ADDRESS)
        }
        if (rowData?.phone) {
            changeFieldValue(RequestorFormConstants.PHONE_NUMBER, rowData.phone);
            changeFieldValue(BillingFormconstants.BILL_TO_PHONE, rowData.phone);
        } else {
            resetFieldValue(RequestorFormConstants.PHONE_NUMBER)
            resetFieldValue(BillingFormconstants.BILL_TO_PHONE)
        }
        if (rowData?.fax) {
            changeFieldValue(RequestorFormConstants.FAX_NUMBER, rowData.fax);
            changeFieldValue(BillingFormconstants.BILL_TO_FAX, rowData.fax);
        } else {
            resetFieldValue(RequestorFormConstants.FAX_NUMBER)
            resetFieldValue(BillingFormconstants.BILL_TO_FAX)
        }

        mirrorData(RequestorFormConstants.FIRST_NAME, rowData?.firstName)
        mirrorData(BillingFormconstants.BILL_TO_FIRST_NAME, rowData?.firstName)
        mirrorData(RequestorFormConstants.LAST_NAME, rowData?.lastName)
        mirrorData(BillingFormconstants.BILL_TO_LAST_NAME, rowData?.lastName)
        mirrorData(RequestorFormConstants.EMAIL, rowData?.email)
        mirrorData(BillingFormconstants.BILL_TO_EMAIL_ADDRESS, rowData?.email)
        mirrorData(RequestorFormConstants.PHONE_NUMBER, rowData?.phone)
        mirrorData(BillingFormconstants.BILL_TO_PHONE, rowData?.phone)
        mirrorData(RequestorFormConstants.FAX_NUMBER, rowData?.fax)
        mirrorData(BillingFormconstants.BILL_TO_FAX, rowData?.fax)

        if (rowData) {
            const updatedValues = {
                [BillingFormconstants.BILL_TO_REQUESTOR_NAME]: values[BillingFormconstants.BILL_TO_REQUESTOR_NAME],
                [BillingFormconstants.BILL_TO_ADDRESS_LINE1]: values[BillingFormconstants.BILL_TO_ADDRESS_LINE1],
                [BillingFormconstants.BILL_TO_STATE]: values[BillingFormconstants.BILL_TO_STATE],
                [BillingFormconstants.BILL_TO_ZIP]: values[BillingFormconstants.BILL_TO_ZIP],
                [BillingFormconstants.BILL_TO_CITY]: values[BillingFormconstants.BILL_TO_CITY],
                [BillingFormconstants.BILL_TO_FIRST_NAME]: rowData.firstName,
                [BillingFormconstants.BILL_TO_LAST_NAME]: rowData.lastName,
                [BillingFormconstants.BILL_TO_ADDRESS_LINE2]: values[RequestorFormConstants.ADDRESS2],
                [BillingFormconstants.BILL_TO_EMAIL_ADDRESS]: rowData.email,
                [BillingFormconstants.BILL_TO_FAX]: rowData.fax,
                [BillingFormconstants.BILL_TO_PHONE]: rowData.phone,
                [BillingFormconstants.REQUIRES_PREPAYMENT]: values[BillingFormconstants.REQUIRES_PREPAYMENT],
                requestorNameId: props.requestorDetails?.requestorID
            }
            props.updateSendToContact?.(
                props.transactionDetails.facility.id,
                props.transactionDetails.id,
                rowData
            );
            const billToRequestor = {
                requestorbillingcontactid: props.transactionDetails.billToContact?.id || null,
                data: {
                    ...generateUpdateBillToRequestorObject(updatedValues),
                    transactionId: props.transactionId
                },
            }
            props.updateBillToRequestorData!(billToRequestor)
        }
    }

    function onChangeSearchLastName(value: string) {
        if (value) {
            if (value.length === 0 && lastNameError === "") {
                setLastNameError("Last Name or MRN is required.")
            } else if (value.length > 0 && lastNameError !== "") {
                setLastNameError("")
            }
        }
    }

    function onChangeSearchDOB(value?: string | Date) {
        if (value && value.toString() != INVALID_DATE) {
            setDOBError("");
            changeFieldValue(FormConstants.SEARCH_DOB, value);
            setDatePickerSelection(value.toString());
        } else {
            setDOBError("DOB is required.");
            changeFieldValue(FormConstants.SEARCH_DOB, "");
        }
    }

    const onPatientTableRowClickHandler = (rowData?: any) => {
        rowData = rowData ?? {};
        mirrorData(FormConstants.PATIENT_NAME, rowData.firstName)
        mirrorData(FormConstants.PATIENT_LAST_NAME, rowData.lastName)
        mirrorData(FormConstants.PATIENT_MIDDLE_NAME, rowData.middleName)
        mirrorData(FormConstants.DOB, rowData.dob)
        rowData.firstName ? changeFieldValue(FormConstants.PATIENT_NAME, rowData.firstName) : resetFieldValue(FormConstants.PATIENT_NAME)
        rowData.lastName ? changeFieldValue(FormConstants.PATIENT_LAST_NAME, rowData.lastName) : resetFieldValue(FormConstants.PATIENT_LAST_NAME)
        rowData.middleName ? changeFieldValue(FormConstants.PATIENT_MIDDLE_NAME, rowData.middleName) : resetFieldValue(FormConstants.PATIENT_MIDDLE_NAME)
        rowData.dob ? changeFieldValue(FormConstants.DOB, rowData.dob ? new Date(rowData.dob) : null) : resetFieldValue(FormConstants.DOB)
        rowData.mrn ? changeFieldValue(FormConstants.MRN_ID, rowData.mrn) : resetFieldValue(FormConstants.MRN_ID)
        resetFieldValue(FormConstants.EMPI_NUMBER)
        resetFieldValue(FormConstants.SEARCH_LAST_NAME)
        resetFieldValue(FormConstants.SEARCH_DOB)

        if (!rowData.firstName) {
            setDisableField(false)
            setAddNewPatient(true)
            mirrorData("notes", "")
            setSelectedPatientId(0)
        } else {
            setDisableField(true)
            setAddNewPatient(false)
            setSelectedPatientId(rowData.id)

            onChangeDetailsOrBillingPaneField(rowData.id, "patientDataid", true)
            props.createPatientRecordSuccess && props.createPatientRecordSuccess({ id: rowData.id })
        }
    }


    const onClickEdit = () => {
        setRequiredContactError("");
        untouch(RequestorFormConstants.REQUESTOR_CONTACT);
        props.transactionDetails.requestorNameID === 0 ? setContactGrid(false) : setContactGrid(true)
    }

    const patientMinDOB = new Date(1900, 0, 1);

    const onEditPatientDetails = (value: string | Date | undefined, fieldName: string) => {
        let patientDetails = {
            transactionId: props.transactionId,
            [FormConstants.PATIENT_NAME]: values[FormConstants.PATIENT_NAME],
            [FormConstants.PATIENT_MIDDLE_NAME]: values[FormConstants.PATIENT_MIDDLE_NAME] || "",
            [FormConstants.PATIENT_LAST_NAME]: values[FormConstants.PATIENT_LAST_NAME],
            [FormConstants.DOB]: values[FormConstants.DOB],
            [FormConstants.EMPI_NUMBER]: values[FormConstants.EMPI_NUMBER] || "",
            [FormConstants.MRN_ID]: values[FormConstants.MRN_ID] || "",
            [fieldName]: value
        }

        if (patientDetails[FormConstants.DOB] && !isNaN(patientDetails[FormConstants.DOB].getTime()) && patientDetails[FormConstants.DOB] < patientMinDOB) {
            return;
        }


        if (patientDetails[FormConstants.PATIENT_NAME] !== props.updatedPatientDetailsAttributes[FormConstants.PATIENT_NAME] ||
            patientDetails[FormConstants.PATIENT_MIDDLE_NAME] !== props.updatedPatientDetailsAttributes[FormConstants.PATIENT_MIDDLE_NAME] ||
            patientDetails[FormConstants.PATIENT_LAST_NAME] !== props.updatedPatientDetailsAttributes[FormConstants.PATIENT_LAST_NAME] ||
            patientDetails[FormConstants.DOB] !== props.updatedPatientDetailsAttributes[FormConstants.DOB] ||
            patientDetails[FormConstants.EMPI_NUMBER] !== props.updatedPatientDetailsAttributes[FormConstants.EMPI_NUMBER] ||
            patientDetails[FormConstants.MRN_ID] !== props.updatedPatientDetailsAttributes[FormConstants.MRN_ID]) {

            const dob = patientDetails[FormConstants.DOB]
            if (patientDetails[FormConstants.PATIENT_NAME]?.length && patientDetails[FormConstants.PATIENT_LAST_NAME]?.length && dob && dob !== INVALID_DATE && !isNaN(dob.getTime())) {
                if (addNewPatient) { //CREATE A PATIENT
                    props.createPatientRecordRequest && props.createPatientRecordRequest(patientDetails, () => { setDisableField(true) })
                    setAddNewPatient(false)
                } else { //EDIT PATIENT
                    patientDetails.patientDataid = selectedPatientId || props.transactionDetails.patient?.id || null
                    props.patchPatientDetailsCreator && props.patchPatientDetailsCreator(patientDetails)
                }
            }
        }
    }

    const updatedActiveTabId =
        activeTabId + 1 <= Object.keys(normalizedTabItems).length
            ? activeTabId + 1
            : activeTabId;

    const getBillingTypeId = () => {
        return props.feeSchedules?.find(item => item.id == feeScheduleId)?.billingTypeId;
    }

    const maskSSNInput = (value?: string) => {
        if (value) {
            changeFieldValue(RequestorFormConstants.SSN, '***-**-***')
        }
    }

    const getDuplicateCompare = () => {
        return {
            transactionID: props.transactionId,
            paymentStatus: "",
            resDataEntryDate: new Date(),
            receivedDate: values[FormConstants.RECEIVED_DATE],
            stdDate: null,
            releaseDate: null,
            patientFirstName: values[FormConstants.PATIENT_NAME],
            patientLastName: values[FormConstants.PATIENT_LAST_NAME],
            patientDOB: values[FormConstants.DOB],
            mrn: values[FormConstants.MRN_ID],
            empi: values[FormConstants.EMPI_NUMBER],
            caseNumber: values[FormConstants.CASE_NUMBER],
            requestorName: values[RequestorFormConstants.REQUESTOR_NAME],
            status: props.transactionStatus?.name,
            requestorAddress: {
                address1: values[RequestorFormConstants.ADDRESS],
                address2: values[RequestorFormConstants.ADDRESS2],
                city: values[RequestorFormConstants.CITY],
                state: values[RequestorFormConstants.STATE],
                zipCode: values[RequestorFormConstants.ZIP],
                phoneNumber: values[RequestorFormConstants.PHONE_NUMBER],
                faxNumber: values[RequestorFormConstants.FAX_NUMBER]
            },
            requestorEmail: values[RequestorFormConstants.EMAIL],
            phone: values[RequestorFormConstants.PHONE_NUMBER],
            requestDocument: ""
        }
    }

    const onChangeSearchRequestorName = (value: string) => {
        if (value.length) { setErrorMessage("") }
    }

    const onChangeSearchContactName = (value: string) => {
        if (value.length) { setErrorMessage("") }
    }

    const onChangeSearchAddress = (value: string) => {
        if (value.length) { setErrorMessage("") }
    }

    const onChangeSearchZip = (value: string) => {
        if (value.length) { setErrorMessage("") }
    }

    const onChangeShowAdvanceRequestorSearch = () => {
        setShowAdvanceRequestorSearch(!showAdvanceRequestorSearch);
        changeFieldValue(RequestorFormConstants.PHONE_FAX_NUMBER, "");
        changeFieldValue(RequestorFormConstants.EMAIL_ADDRESS, "");
        changeFieldValue(RequestorFormConstants.SEARCH_REQUESTOR_NAME, "");
        changeFieldValue(RequestorFormConstants.SEARCH_CONTACT_NAME, "");
        changeFieldValue(RequestorFormConstants.SEARCH_ADDRESS, "");
        changeFieldValue(RequestorFormConstants.SEARCH_ZIP, "");
    }

    const onChangeSearchName = (value: string) => {
        setSearchName(value);
    }

    const onBlurDigitalFaxField = (value: string, _name: string, _event: React.FocusEvent) => {
        if (value.length) {
            changeFieldValue(BillingFormconstants.DIGITAL_FAX, value)
            props.setConfirmFaxNumberAction && props.setConfirmFaxNumberAction(value)
            const faxNumber = values[RequestorFormConstants.FAX_NUMBER]
            if (faxNumber.length && value !== faxNumber) {
                setErrorMessage("Fax number entered does not match the assigned requestor contact fax number")
            } else {
                setErrorMessage("");
                props.putDigitalFaxValidation && props.putDigitalFaxValidation(props.transactionId, faxNumber, true);
            }
        } else {
            setErrorMessage("")
        }
    }

    return (
        <div className="right-pane" onKeyDown={() => props.userHasMadeChanged()}>
            {/* Headless: own the Billing/Requestor-tab-scoped effects extracted
                from this orchestrator (Spec #34098 / F1a, AC13). Always
                rendered, matching the pre-refactor firing semantics. */}
            <DataEntryDetailsRightPaneBillingSection
                additionalChargeRecords={props.additionalChargeRecords}
                releaseMethodId={props.transactionDetails.releaseMethod?.id}
                feeScheduleId={props.transactionDetails.feeSchedule?.id}
                shippingService={props.transactionDetails.shippingService}
                isInternalRequest={props.transactionDetails.transactionRequest?.isInternalRequest}
                updateDeliveryInstructionsStatus={props.updateDeliveryInstructionsStatus}
                certificationTemplateValue={values[BillingFormconstants.CERTIFICATION_TEMPLATE]}
                changeFieldValue={changeFieldValue}
                setDisableShippingDropdown={setDisableShippingDropdown}
                setShowDigitalFax={setShowDisgitalFax}
                setFeeScheduleId={setFeeScheduleId}
                setDisableFeeScheduleDropdown={setDisableFeeScheduleDropdown}
                setDisableReleaseMethodDropdown={setDisableRealeaseMethodDropdown}
                setDisableRemoveCertification={setDisableRemoveCertification}
            />
            <DataEntryDetailsRightPaneRequestorSection
                activeTabId={activeTabId}
                requestType={requestType}
                canEditPatient={props.canEditPatient}
                noBarcodeValue={values[RequestorFormConstants.NO_BARCODE]}
                transactionDdsSsn={props.transactionDetails.transactionDds?.ssn}
                ssnValue={values[RequestorFormConstants.SSN]}
                requestorDetails={props.requestorDetails}
                requestPurpose={props.transactionDetails.requestPurpose}
                organizationId={props.organizationId}
                transactionId={props.transactionId}
                transactionDDS={props.transactionDDS}
                readBarCodeDDSAPIStatus={props.readBarCodeDDSAPIStatus}
                changeFieldValue={changeFieldValue}
                setDisableField={setDisableField}
                setDisableDDSField={setDisableDDSField}
                setLastUsedRequestorInfo={props.setLastUsedRequestorInfo}
                setErrorMessage={setErrorMessage}
                setDOBError={setDOBError}
                setLastNameError={setLastNameError}
            />
            <DuplicateTXPopup compareTransaction={getDuplicateCompare()} userId={global.userID}></DuplicateTXPopup>
            {wait ? <CompleteTransactionWaiting /> : <></>}

            <div style={{ position: "relative", flex: "1 1 auto" }}>
                {/* Details Entry Right panel population Tab 1 Details*/}
                {activeTabId === 1 ?
                    <div className="details-tab-right-pane">
                        <RequestTypePurposeField
                            requestTypes={props.requestTypes}
                            value={requestType}
                            purposeValue={requestPurpose}
                            isAiPreSelected={false}
                            dispatch={props.dispatch!}
                            onRequestTypeChange={onChangeRequestType}
                            onRequestPurposeChange={onChangeRequestPurpose}
                        />

                        <div className='requestor-info-container'>
                            <div className="new-panel-header section-headers" style={{ width: '100%', marginLeft: 12, marginTop: 50 }}> {'Patient Information'} </div>
                            <div className='filter-text'><span className='requestor-filter-text' style={{ marginBottom: 23 }}>Search and select a patient</span></div>
                            <div className="data-entry requestor-search-Phone placeholder-style">
                                <Field
                                    name={FormConstants.SEARCH_LAST_NAME}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Last Name/MRN",
                                        placeholder: "last name or mrn",
                                        required: true,
                                        maxLength: InputFieldLength.NAME_MAX_LENGTH,
                                        errorMessage: lastNameError,
                                        onBlur: onChangeSearchLastName,
                                        suppressEnterSubmit: true
                                    }}
                                />
                            </div>

                            <div className="data-entry requestor-search-email  placeholder-style">
                                <DateField
                                    label={"Date of Birth"}
                                    placeholder={"mm/dd/yyyy"}
                                    required={true}
                                    maxDate={new Date()}
                                    minDate={patientMinDOB}
                                    errMsg={DOBError}
                                    onChange={onChangeSearchDOB}
                                    value={datePickerSelection}
                                />
                            </div>

                            <div className="data-entry requestor-search-icon">
                                <IconWithButton
                                    onButtonClick={onClickPatientSerach}
                                    buttonText='Search'
                                    rotateArrow={showPatientGrid ? 90 : 0}
                                />
                            </div>
                        </div>
                        <span className='horizontal-line' style={{ marginTop: '4%' }}></span>

                        {showPatientGrid ?
                            <CustomTable
                                onTableRowClickHandler={onPatientTableRowClickHandler}
                                setGrid={setPatientGrid}
                                rows={props.patientSearchDetails ?? []}
                                headCells={headCellsPatient}
                                addNewText="Add new Patient"
                                defaultSortCol="lastName"
                                onAddNew={() => setAddNewPatient(true)}
                                apiStatus={props.getPatientSearchResultsAPIStatus}
                                showAddNew={true}
                            />
                            : null}

                        <div className="data-entry patient-firstName placeholder-style">
                            <Field
                                name={FormConstants.PATIENT_NAME}
                                component={ReduxFormTextField}
                                props={{
                                    label: "Patient name",
                                    placeholder: "first name",
                                    maxLength: InputFieldLength.NAME_MAX_LENGTH,
                                    required: true,
                                    disabled: isDisableField,
                                    onBlur: onEditPatientDetails,
                                    suppressEnterSubmit: true
                                }}
                            />
                        </div>
                        <div className="data-entry patient-middleName  placeholder-style">
                            <Field
                                name={FormConstants.PATIENT_MIDDLE_NAME}
                                component={ReduxFormTextField}
                                props={{
                                    label: " ",
                                    placeholder: "M",
                                    disabled: isDisableField,
                                    suppressEnterSubmit: true
                                }}
                            />
                        </div>
                        <div className="data-entry patient-lastName placeholder-style">
                            <Field
                                name={FormConstants.PATIENT_LAST_NAME}
                                component={ReduxFormTextField}
                                props={{
                                    label: " ",
                                    placeholder: "last name",
                                    maxLength: InputFieldLength.NAME_MAX_LENGTH,
                                    disabled: isDisableField,
                                    onBlur: onEditPatientDetails,
                                    suppressEnterSubmit: true
                                }}
                            />
                        </div>

                        <div style={{ "height": "20px", "flexBasis": "100%" }}>&nbsp;</div>

                        <div className="data-entry patient-dob">
                            <Field
                                name={FormConstants.DOB}
                                component={ReduxFormDateField}
                                props={{
                                    label: "Patient date of birth",
                                    placeholder: "mm/dd/yyyy",
                                    maxDate: new Date(),
                                    minDate: patientMinDOB,
                                    required: true,
                                    disabled: isDisableField,
                                    onChange: onEditPatientDetails
                                }}
                            />
                        </div>

                        <div className="data-entry mrn-number  placeholder-style">
                            <Field
                                name={FormConstants.MRN_ID}
                                component={ReduxFormTextField}
                                props={{
                                    label: "Medical Record Number (MRN)",
                                    placeholder: "MRN12346789",
                                    maxLength: InputFieldLength.MEDICAL_RECORD_NUMBER_MAX_LENGTH,
                                    onBlur: onEditPatientDetails,
                                    suppressEnterSubmit: true
                                }}
                            />
                        </div>

                        {props.transactionDetails.facility?.useRequestID ?
                            <div className="data-entry placeholder-style">
                                <Field
                                    name={FormConstants.REQUEST_ID}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Request ID",
                                        placeholder: "XXXXXX-XXXX",
                                        maxLength: InputFieldLength.REQUEST_ID_MAX_LENGTH,
                                        onBlur: onChangeDetailsOrBillingPaneField,
                                        suppressEnterSubmit: true
                                    }}
                                />
                            </div> : <div className="data-entry placeholder-style"></div>}

                        {props.transactionDetails.facility.useEMPI ? <div className="data-entry empi-number  placeholder-style">
                            <Field
                                name={FormConstants.EMPI_NUMBER}
                                component={ReduxFormTextField}
                                props={{
                                    label: "EMPI",
                                    placeholder: "123456789",
                                    maxLength: InputFieldLength.EMPI_MAX_LENGTH,
                                    onBlur: onEditPatientDetails,
                                    suppressEnterSubmit: true
                                }}
                            />
                        </div> : <div className="data-entry empi-number placeholder-style" style={{ display: 'none' }} />}

                        <span className='horizontal-line' style={{ marginTop: '4%' }}></span>
                        <div className="data-entry authorization-date">
                            <AuthorizationDateField
                                value={values[FormConstants.AUTHORIZATION_DATE]}
                                requestPurposeId={requestPurpose}
                                visible={requestType != DISCLOSURE_ACCOUNTING}
                                dispatch={props.dispatch!}
                                onAuthorizationDateChange={(value) => autosaveBillingPaneField(value, FormConstants.AUTHORIZATION_DATE)}
                            />
                        </div>

                        <div className="data-entry request-date">
                            <RequestDateField
                                value={values[FormConstants.REQUEST_DATE]}
                                visible={requestType != DISCLOSURE_ACCOUNTING}
                                dispatch={props.dispatch!}
                                onRequestDateChange={(value) => autosaveBillingPaneField(value, FormConstants.REQUEST_DATE)}
                            />
                        </div>

                        <div className="data-entry received-date">
                            <Field
                                name={FormConstants.RECEIVED_DATE}
                                component={ReduxFormDateField}
                                props={{
                                    label: "Received date",
                                    placeholder: "mm/dd/yyyy",
                                    maxDate: new Date(),
                                    minDate: new Date((new Date()).setHours(0, 0, 0, 0) - (365 * 24 * 60 * 60 * 1000)),
                                    required: requestType != DISCLOSURE_ACCOUNTING || props?.facilityAdditionalFields?.enableNonHIMReceivedDateRequired,
                                    onChange: onChangeDetailsOrBillingPaneField
                                }}
                            />
                        </div>

                        {requestType != DISCLOSURE_ACCOUNTING ? <div className="data-entry due-date">
                            <Field
                                name={FormConstants.DUE_DATE}
                                component={ReduxFormDateField}
                                props={{
                                    label: "Due date",
                                    placeholder: "mm/dd/yyyy",
                                    minDate: DEFAULT_MIN_DATE,
                                    maxDate: DEFAULT_MAX_DATE,
                                    onChange: onChangeDetailsOrBillingPaneField
                                }}
                            />
                        </div> : null}

                        <div className="data-entry clinic-responsible">
                            <ClinicResponsibleField
                                value={values[FormConstants.CLINIC_RESPONISBLE]}
                                useClinics={Boolean(props.transactionDetails.facility?.useClinics)}
                                useDepartments={Boolean(props.transactionDetails.facility?.useDepartments)}
                                discloseInstitutions={props.discloseInstitutions}
                                dispatch={props.dispatch!}
                                onClinicResponsibleChange={(value) => autosaveBillingPaneField(value, FormConstants.CLINIC_RESPONISBLE)}
                            />
                        </div>

                        {requestType != DISABILITY_OR_SOCIAL_SECURITY &&
                            <div className="data-entry case-number placeholder-style">
                                <CaseNumberField
                                    value={values[FormConstants.CASE_NUMBER]}
                                    required={[3, 53].includes(requestType)}
                                    dispatch={props.dispatch!}
                                    onCaseNumberBlur={(value) => autosaveBillingPaneField(value, FormConstants.CASE_NUMBER)}
                                />
                            </div>
                        }

                        {requestType == AUDIT ? <>
                            <div className="data-entry request-type placeholder-style">
                                <Field
                                    name={FormConstants.AUDIT_TYPE}
                                    component={ReduxFormDropdownField}
                                    props={{
                                        label: "Audit Type",
                                        required: true,
                                        options: auditTypesOptions,
                                        onChange: onChangeDetailsOrBillingPaneField

                                    }}
                                />
                            </div>
                            <div className="data-entry request-type placeholder-style">
                                <Field
                                    name={FormConstants.ON_BEHALF_OF}
                                    component={ReduxFormDropdownField}
                                    props={{
                                        label: "On Behalf Of",
                                        required: true,
                                        options: onBehalfOfOptions,
                                        onChange: onChangeDetailsOrBillingPaneField

                                    }}
                                />
                            </div></> : null}

                        {isVisibleSensitiveInfoToRelease && <div
                            className="disclosure-accordion"
                            onMouseUp={() => props.userHasMadeChanged()}
                        >
                            <RecordsRequestedField
                                releaseInfo={props.transactionDetails.releaseInfo}
                                requestComments={props.transactionDetails.requestComments}
                                organizationId={props.transactionDetails.facility.id}
                                requestBufferId={props.transactionDetails.id}
                                dob={props.formState.values?.[FormConstants.DOB] ? new Date(props.formState.values[FormConstants.DOB]) : undefined}
                                visible
                                saveInformationToRelease={props.saveInformationToRelease}
                            />
                        </div>}

                        {isVisibleSensitiveInfoToRelease && <div
                            className="disclosure-accordion"
                            onMouseUp={() => props.userHasMadeChanged()}
                        >
                            <SensitiveInfoField
                                data={props.transactionDetails.sensitiveInfo}
                                transactionId={props.transactionId}
                                dispatch={props.dispatch!}
                                visible
                                errorMsg={props.formSyncErrors?.[FormConstants.SENSITIVE_INFORMATION]}
                                saveAndUpdateSensitiveInfo={props.saveAndUpdateSensitiveInfo}
                            />
                        </div>}

                        {requestType == DISCLOSURE_ACCOUNTING ? <div className='disclosure-accordion' onMouseUp={() => props.userHasMadeChanged()}>
                            <AccordionComponent
                                activeTabId={activeTabId}
                                requestTypeValue={'66'}
                                heading='Disclosure Information'
                                phiCodes={props.selectedPHICodes}
                                onBlur={onBlurDisclosureInformationFields}
                            />
                        </div> : null}

                    </div> : null}

                {/* requestor tab */}

                {activeTabId === 2 ?
                    /* Form fields UI mockup for requestor tab */
                    <div id='requestor-tab-right-pane' className='details-tab-right-pane'>
                        <div style={{ flexDirection: 'column', flexWrap: 'nowrap' }} className='requestor-info-container'>
                            <div className="new-panel-header section-headers" style={{ width: '98%', marginLeft: 12 }}> {'Requestor Information'} </div>
                            {requestType == DISABILITY_OR_SOCIAL_SECURITY &&
                                (
                                    <>
                                        <div style={{ marginLeft: "0", marginTop: 12 }} className="row dds-row-1">
                                            <div style={{ flexBasis: "33%" }}>
                                                <Field
                                                    name={RequestorFormConstants.RQID}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "RQID",
                                                        placeholder: "Enter RQID",
                                                        maxLength: 50,
                                                        onChange: onChangeRQID,
                                                        required: props.formState.values[RequestorFormConstants.NO_BARCODE] !== undefined ? !props.formState.values[RequestorFormConstants.NO_BARCODE] : true,
                                                        errorMessage: "",
                                                        onBlur: onBlurRQID,
                                                        disabled: isDisableDDSField,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flexBasis: "33%" }}>
                                                <Field
                                                    name={RequestorFormConstants.TX_SITE_CODE}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "TX Site Code",
                                                        placeholder: "Site Code",
                                                        maxLength: 10,
                                                        onChange: onChangeTXSiteCode,
                                                        required: props.formState.values[RequestorFormConstants.NO_BARCODE] !== undefined ? !props.formState.values[RequestorFormConstants.NO_BARCODE] : true,
                                                        errorMessage: "",
                                                        onBlur: onBlurTXSiteCode,
                                                        disabled: isDisableDDSField,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flexBasis: "33%" }}>
                                                <Field
                                                    name={RequestorFormConstants.DOC_RETURN_CODE}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Doc Return Code",
                                                        placeholder: "Doc Return Code",
                                                        maxLength: 50,
                                                        onChange: onChangeDR,
                                                        required: props.formState.values[RequestorFormConstants.NO_BARCODE] !== undefined ? !props.formState.values[RequestorFormConstants.NO_BARCODE] : true,
                                                        errorMessage: drErrorMessage,
                                                        onBlur: onBlurDR,
                                                        disabled: isDisableDDSField,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ marginLeft: "0" }} className="row dds-row-2">
                                            <div style={{ flexBasis: "33%" }}>
                                                <Field
                                                    name={RequestorFormConstants.SSN}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "SSN",
                                                        placeholder: "SSN",
                                                        maxLength: 9,
                                                        onChange: onChangeSSN,
                                                        required: props.formState.values[RequestorFormConstants.NO_BARCODE] !== undefined ? !props.formState.values[RequestorFormConstants.NO_BARCODE] : true,
                                                        errorMessage: "",
                                                        onBlur: onBlurSSN,
                                                        disabled: isDisableDDSField,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flexBasis: "33%" }}>
                                                <Field
                                                    name={RequestorFormConstants.DOC_TYPE}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Doc Type",
                                                        placeholder: "Doc Type",
                                                        maxLength: 4,
                                                        onChange: onChangeDocType,
                                                        required: props.formState.values[RequestorFormConstants.NO_BARCODE] !== undefined ? !props.formState.values[RequestorFormConstants.NO_BARCODE] : true,
                                                        errorMessage: docTypeErrorMessage,
                                                        onBlur: onBlurDocType,
                                                        disabled: isDisableDDSField,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flexBasis: "33%" }}>
                                                <Field
                                                    name={RequestorFormConstants.ROUTING_FIELD}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Routing Field",
                                                        placeholder: "Routing Field",
                                                        maxLength: 50,
                                                        onChange: onChangeRF,
                                                        required: props.formState.values[RequestorFormConstants.NO_BARCODE] !== undefined ? !props.formState.values[RequestorFormConstants.NO_BARCODE] : true,
                                                        errorMessage: rfErrorMessage,
                                                        onBlur: onBlurRF,
                                                        disabled: isDisableDDSField,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row no-barcode">

                                            <div className="select-all-check">
                                                <Field
                                                    name={RequestorFormConstants.NO_BARCODE}
                                                    component={ReduxFormcheckboxField}
                                                    props={{
                                                        fieldlabel: "",
                                                        checkboxLabel: 'No Barcode',
                                                        onChange: onChangeNoBarcode,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="data-entry case-number placeholder-style" style={{ width: '33.5%', marginTop: -8 }}>
                                            <Field
                                                name={FormConstants.CASE_NUMBER}
                                                component={ReduxFormTextField}
                                                props={{
                                                    label: "Case number",
                                                    placeholder: "123456789",
                                                    maxLength: InputFieldLength.CASE_NUMBER_MAX_LENGTH,
                                                    required: true,
                                                    onBlur: onChangeDetailsOrBillingPaneField,
                                                    suppressEnterSubmit: true
                                                }}
                                            />
                                        </div>
                                        <span className='horizontal-line' style={{ marginTop: '4%' }}></span>
                                    </>
                                )
                            }

                            {/* Same as option */}
                            {(props.lastUsedRequestorContact && props.organizationId === props.lastUsedRequestorContact.org && props.transactionId !== props.lastUsedRequestorContact.transactionId)
                                &&
                                <div className='same-as-option'>
                                    <p className='form-label same-as-label'>To use Requestor: {"  "}
                                        <span className='same-as-identity'>{props.lastUsedRequestorContact.requestorName}</span>
                                        - Contact:
                                        <span className='same-as-identity'>{(props.lastUsedRequestorContact.firstName || props.lastUsedRequestorContact.lastName) ? `${props.lastUsedRequestorContact.firstName} ${props.lastUsedRequestorContact.lastName}` : '(None)'} </span>
                                        for this transaction, click
                                    </p>
                                    <IconWithButton onButtonClick={() => onRequestorTableRowClickHandler(props.lastUsedRequestorContact)} buttonText={`Same As`} hideArrowIcon={true} isSameAs={true} />
                                </div>}

                            {/* Requestor Search */}
                            <div
                                className='filter-text'
                                style={{ flexBasis: '10%', marginBottom: 13 }}
                            >
                                <span
                                    style={{ marginLeft: 12 }}
                                    className={"requestor-filter-text" + (requestType == DISABILITY_OR_SOCIAL_SECURITY ? "requestor-filter-text-adj" : "")}
                                >
                                    Search for requestor
                                </span>
                            </div>

                            <div id='requestor-search-fields' className="row">
                                {requestType == DISABILITY_OR_SOCIAL_SECURITY && <div style={{ flexBasis: "33%" }}>
                                    <Field
                                        name={RequestorFormConstants.RQ_SITE_CODE}
                                        component={ReduxFormTextField}
                                        props={{
                                            label: "RQ Site Code",
                                            placeholder: "Site Code",
                                            maxLength: 10,
                                            onChange: onChangeRQSiteCode,
                                            errorMessage: "",
                                            suppressEnterSubmit: true
                                        }}
                                    />
                                </div>}
                                {/* If Request Type is Internal */}
                                {requestType == INTERNAL ? <div style={{ flexBasis: "25%" }}>
                                    <Field
                                        name={RequestorFormConstants.INTENRNAL_REQUESTOR}
                                        component={ReduxFormTextField}
                                        props={{
                                            label: "Name",
                                            placeholder: "Name",
                                            maxLength: 50,
                                            onChange: onChangeSearchName,
                                            suppressEnterSubmit: true
                                        }}
                                    />
                                </div>
                                    :
                                    <div id='phone/fax-search' style={{ flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? "33%" : "25%" }}>
                                        <Field
                                            name={RequestorFormConstants.PHONE_FAX_NUMBER}
                                            component={ReduxFormTextField}
                                            props={{
                                                label: "Phone/Fax",
                                                placeholder: "XXX-XXX-XXXX",
                                                maxLength: 12,
                                                onChange: onChangeFaxOrPhoneOrEmail,
                                                errorMessage: !showAdvanceRequestorSearch && errorMessage.length > 0 ? errorMessage : null,
                                                suppressEnterSubmit: true
                                            }}
                                        />
                                    </div>}
                                <div id='email-search' style={{ flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? "33%" : "25%" }}>
                                    <Field
                                        name={RequestorFormConstants.EMAIL_ADDRESS}
                                        component={ReduxFormTextField}
                                        props={{
                                            label: "Email",
                                            placeholder: "example@mail.com",
                                            maxLength: 50,
                                            onChange: (e: string) => { setSearchEmail(e); onChangeFaxOrPhoneOrEmail(e) },
                                            errorMessage: !showAdvanceRequestorSearch && requestType != INTERNAL && errorMessage.length > 0 ? "  " : null,
                                            suppressEnterSubmit: true
                                        }}
                                    />
                                </div>
                                <div
                                    style={{
                                        alignSelf: 'flex-start',
                                        marginTop: 21,
                                        marginLeft: requestType == DISABILITY_OR_SOCIAL_SECURITY ? 0 : 13,
                                        position: 'relative',
                                        flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? 'auto' : '50%',
                                    }}
                                >
                                    <IconWithButton
                                        onButtonClick={onClickSearch}
                                        buttonText='Search'
                                        rotateArrow={showRequestorGrid ? 90 : 0}
                                    />
                                </div>
                            </div>

                            <div className='advanced-search-container' style={{ position: 'relative', display: 'flex', flexDirection: 'column-reverse', top: 0 }}>
                                {showAdvanceRequestorSearch &&
                                    <div>
                                        <div id='advanced-search-content' style={{ marginLeft: "0" }} className="row">
                                            <div id='address-search' style={{ flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? "33%" : "25%" }}>
                                                <Field
                                                    name={RequestorFormConstants.SEARCH_ADDRESS}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Address",
                                                        placeholder: "123 main st",
                                                        maxLength: 70,
                                                        onChange: onChangeSearchAddress,
                                                        errorMessage,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>

                                            <div id='zip-search' style={{ flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? "33%" : "25%" }}>
                                                <Field
                                                    name={RequestorFormConstants.SEARCH_ZIP}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Zip Code",
                                                        placeholder: "12345",
                                                        maxLength: 10,
                                                        onChange: onChangeSearchZip,
                                                        errorMessage: errorMessage.length > 0 ? "  " : null,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>

                                        </div>
                                        <div id='advanced-search-content' style={{ marginLeft: "0" }} className="row">
                                            <div id='requestor-name-search' style={{ flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? "33%" : "25%" }}>
                                                <Field
                                                    name={RequestorFormConstants.SEARCH_REQUESTOR_NAME}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Requestor Name",
                                                        placeholder: "Name",
                                                        maxLength: 50,
                                                        onChange: onChangeSearchRequestorName,
                                                        errorMessage,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>

                                            <div id='requestor-contact-search' style={{ flexBasis: requestType == DISABILITY_OR_SOCIAL_SECURITY ? "33%" : "25%" }}>
                                                <Field
                                                    name={RequestorFormConstants.SEARCH_CONTACT_NAME}
                                                    component={ReduxFormTextField}
                                                    props={{
                                                        label: "Contact",
                                                        placeholder: "Contact",
                                                        maxLength: 50,
                                                        onChange: onChangeSearchContactName,
                                                        errorMessage: errorMessage.length > 0 ? "  " : null,
                                                        suppressEnterSubmit: true
                                                    }}
                                                />
                                            </div>

                                        </div></div>
                                }
                            </div>
                            <div
                                id='advanced-search-toggle'
                                className="row"
                                style={{
                                    justifyContent: requestType == DISABILITY_OR_SOCIAL_SECURITY ? 'flex-start' : 'space-between',
                                    flexDirection: requestType == DISABILITY_OR_SOCIAL_SECURITY ? 'column' : 'row',
                                    marginRight: requestType == DISABILITY_OR_SOCIAL_SECURITY ? '3px' : '-15px',
                                }}
                            >
                                {requestType != INTERNAL ?
                                    <div id='icon+label'>
                                        <span className='edit-contact'
                                            onClick={() => onChangeShowAdvanceRequestorSearch()}>
                                            <ArrowForwardIos style={{ fontSize: 18, transform: (showAdvanceRequestorSearch ? 'rotate(90deg)' : '') }} />Advanced Search
                                        </span>
                                    </div>
                                    :
                                    <div>
                                        <span></span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='search-requestor-table'>
                            {showRequestorGrid ?
                                <CustomTable
                                    onTableRowClickHandler={onRequestorTableRowClickHandler}
                                    setGrid={setRequestorGrid}
                                    rows={props.requestorSearchDetails ?? []}
                                    headCells={headCellsRequestor}
                                    addNewText="Add new Requestor"
                                    defaultSortCol="default"
                                    onAddNew={() => {
                                        props.updateRequestorDetails?.(undefined);
                                        setRequestorFieldEnabled(true);
                                        props.resetRequestorContactList!();
                                        setEnableEditReqContact(false);
                                    }}
                                    apiStatus={props.getRequestorSearchDetailsAPIStatus}
                                    showAddNew={showAddNewRequestor}
                                />
                                : null}
                        </div>
                        <span className="horizontal-line" style={{ height: 1, flexBasis: 'auto', marginTop: requestType == DISABILITY_OR_SOCIAL_SECURITY && showAdvanceRequestorSearch ? 23 : '4%' }}></span>

                        <div className='requestor-info-container requestor-input-container' style={{ marginTop: 8 }}>
                            <div className='data-entry requestor-info placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.REQUESTOR_NAME}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Requestor name",
                                        required: true,
                                        placeholder: "Requestor Name",
                                        maxLength: 100,
                                        onChange: onChangeRequestorName,
                                        onBlur: onBlurRequestorTabFields,
                                        disabled: !requestorFieldEnabled,
                                        suppressEnterSubmit: true
                                    }}
                                />
                            </div>

                            <div className='data-entry requestor-info placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.ADDRESS}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Address",
                                        required: true,
                                        placeholder: "Address line 1",
                                        maxLength: 70,
                                        onChange: onChangeAddress1,
                                        onBlur: onBlurRequestorTabFields,
                                        disabled: !requestorFieldEnabled,
                                        suppressEnterSubmit: true
                                    }}
                                />
                            </div>

                            <div className='data-entry requestor-addressLine2 placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.ADDRESS2}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "",
                                        maxLength: 70,
                                        placeholder: "P.O. Box, Suite, Apt #",
                                        onChange: onChangeAddress2,
                                        onBlur: onBlurRequestorTabFields,
                                        disabled: !requestorFieldEnabled,
                                        suppressEnterSubmit: true

                                    }}
                                />
                            </div>

                            <div className='data-entry requestor-city placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.CITY}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "City",
                                        required: true,
                                        placeholder: "City",
                                        maxLength: 30,
                                        onChange: onChangeCity,
                                        onBlur: onBlurRequestorTabFields,
                                        disabled: !requestorFieldEnabled,
                                        suppressEnterSubmit: true

                                    }}
                                />
                            </div>

                            <div className='data-entry requestor-state placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.STATE}
                                    component={ReduxFormDropdownField}
                                    props={{
                                        label: "State",
                                        required: true,
                                        options: [
                                            { label: "- Select -", value: "", disabled: true, hidden: true },
                                            ...UNITED_STATES.map(st => ({ label: st.abbreviation, value: st.abbreviation })),
                                        ],
                                        placeholder: "- Select -",
                                        onChange: onChangeState,
                                        onBlur: onBlurRequestorTabFields,
                                        disabled: !requestorFieldEnabled,
                                        suppressEnterSubmit: true
                                    } as ReduxDropdownProps}
                                />
                            </div>
                            <div className='data-entry requestor-zip placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.ZIP}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Zip",
                                        required: true,
                                        placeholder: "Zip code",
                                        maxLength: 5,
                                        onChange: onChangeZip,
                                        onBlur: onBlurRequestorTabFields,
                                        disabled: !requestorFieldEnabled,
                                        suppressEnterSubmit: true

                                    }}
                                />
                            </div>
                        </div>

                        <div className='contact-info-container' id='requestorContactForm'>
                            <div className='panel-header-and-edit'>
                                <div className="new-panel-header section-headers" style={{ width: '98%', marginLeft: 12 }}>
                                    Contacts
                                </div>
                                <div className='data-entry' style={{ position: 'absolute', right: 12 }}>
                                    <span className={!contactsLoaded || showContactGrid ? 'edit-contact edit-contact-disabled' : 'edit-contact edit-contact-enabled'}
                                        onClick={contactsLoaded ? () => onClickEdit() : () => { }}>
                                        <EditIcon className={!contactsLoaded || showContactGrid ? 'edit-icon-disabled' : 'edit-icon-enabled'} />
                                        Assign Contact
                                    </span>
                                </div>
                            </div>
                            <Field
                                name={RequestorFormConstants.REQUESTOR_CONTACT}
                                component={ReduxFormValidationError}
                                props={{
                                    errorMessage: requiredContactError,
                                    suppressEnterSubmit: true
                                }}
                            />
                            {showContactGrid ?
                                <CustomTable
                                    onTableRowClickHandler={onContactTableRowClickHandler}
                                    setGrid={setContactGrid}
                                    rows={props.requestorContactDetails ?? []}
                                    headCells={headCellsContact}
                                    addNewText="Add new Contact"
                                    defaultSortCol={searchEmail ? "email" : (searchPhone ? "phonefax" : "firstName")}
                                    defaultSortVal={searchEmail || searchPhone}
                                    onAddNew={() => {
                                        setAddNewContact(true)
                                        setEnableEditReqContact(true)
                                    }}
                                    showAddNew={true}
                                    apiStatus={props.getContactSearchDetailsAPIStatus}
                                />
                                : null}


                            <div className='data-entry requestor-first-name placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.FIRST_NAME}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "First name",
                                        placeholder: "First Name",
                                        maxLength: 30,
                                        onchange: onChangeFirstName,
                                        onBlur: (v, f, e) => {
                                            onChangeFirstName(v, true);
                                            onBlurRequestorTabFields(v, f, e);
                                        },
                                        suppressEnterSubmit: true,
                                        disabled: !enableEditReqContact

                                    }}
                                />
                            </div>
                            <div className='data-entry requestor-last-name placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.LAST_NAME}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Last name",
                                        placeholder: "Last Name",
                                        maxLength: 30,
                                        onchange: onChangeLastName,
                                        onBlur: (v, f, e) => {
                                            onChangeLastName(v, true);
                                            onBlurRequestorTabFields(v, f, e);
                                        },
                                        suppressEnterSubmit: true,
                                        disabled: !enableEditReqContact

                                    }}
                                />
                            </div>
                            <div className='data-entry placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.EMAIL}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Email",
                                        placeholder: "example@mail.com",
                                        maxLength: 50,
                                        onchange: onChangeEmail,
                                        onBlur: (v, f, e) => {
                                            onChangeEmail(v, true);
                                            onBlurRequestorTabFields(v, f, e);
                                        },
                                        suppressEnterSubmit: true,
                                        disabled: !enableEditReqContact,
                                        errorMessage: props.formState.syncErrors && props.formState.syncErrors[RequestorFormConstants.EMAIL]

                                    }}
                                />
                            </div>

                            <div className='data-entry placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.PHONE_NUMBER}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Phone number",
                                        placeholder: "XXX-XXX-XXXXxXXXXX",
                                        maxLength: 30,
                                        onchange: onChangePhone,
                                        onBlur: (v, f, e) => {
                                            onChangePhone(v, true);
                                            onBlurRequestorTabFields(v, f, e);
                                        },
                                        suppressEnterSubmit: true,
                                        disabled: !enableEditReqContact,
                                        errorMessage: props.formState.syncErrors && props.formState.syncErrors[RequestorFormConstants.PHONE_NUMBER]
                                    }}
                                />
                            </div>
                            <div className='data-entry placeholder-style'>
                                <Field
                                    name={RequestorFormConstants.FAX_NUMBER}
                                    component={ReduxFormTextField}
                                    props={{
                                        label: "Fax number",
                                        placeholder: "XXX-XXX-XXXX",
                                        maxLength: 12,
                                        onchange: onChangeFax,
                                        onBlur: (v, f, e) => {
                                            onChangeFax(v, true);
                                            onBlurRequestorTabFields(v, f, e);
                                        },
                                        suppressEnterSubmit: true,
                                        disabled: !enableEditReqContact,
                                        errorMessage: props.formState.syncErrors && props.formState.syncErrors[RequestorFormConstants.PHONE_FAX_NUMBER]
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    : null}

                {activeTabId === 3 ?
                    <div className="billing-right-pane">
                        <Row>
                            <Col>
                                <p className="font-weight-bold mb-3 billing-desc">
                                    Enter any overrides to the fee schedule for this request.
                                </p>
                            </Col>
                            <span className="horizontal-line"></span>
                        </Row>
                        <Row>
                            <Col xs={6} md={6} className="pl-0">
                                <div className="data-entry purpose-type">
                                    <Field
                                        name={BillingFormconstants.FEE_SCHEDULES}
                                        component={DropdownField}
                                        props={{
                                            label: "Use this Fee Schedule",
                                            required: false,
                                            options: [
                                                { label: "- Select -", value: 0, disabled: true, hidden: true },
                                                ...props.feeSchedules!.map(fee => ({ label: fee.name, value: fee.id })),
                                            ],
                                            disabled: disableFeeScheduleDropDown,
                                            value: feeScheduleId,
                                            onChange: onChangeFeeSchedule
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col xs={6} md={6} className="pl-0">
                                <div className="data-entry purpose-type">
                                    <Field
                                        name={BillingFormconstants.RELEASE_METHODS}
                                        component={ReduxFormDropdownField}
                                        props={{
                                            label: "Release Method",
                                            options: [
                                                { label: "- Select -", disabled: true, hidden: true },
                                                ...(props.releaseMethods ?? []).map(method => ({
                                                    label: method.name,
                                                    value: method.id
                                                }))
                                            ] as DropdownOption[],
                                            disabled: disableRealeaseMethodDropDown,
                                            onChange: (v: any, f: string) => onChangeDetailsOrBillingPaneField(v, f, true)
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6} md={6} className="pl-0">
                                <div className="data-entry purpose-type">
                                    <Field
                                        name={BillingFormconstants.SHIPPING_SERVICES}
                                        component={ReduxFormDropdownField}
                                        props={{
                                            label: "Shipping Service",
                                            options: props.shippingServices,
                                            disabled: disableShippingDropDown,
                                            onChange: onChangeDetailsOrBillingPaneField
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="data-entry ">
                                    <Field
                                        name={BillingFormconstants.CHARGE_FOR_POSTAGE}
                                        component={ReduxFormRadioField}
                                        props={{
                                            fieldlabel: "Charge for Postage?",
                                            radioLabel: 'Yes',
                                            defaultSelected: props.transactionDetails.postageIsApplied,
                                            disabled: disableShippingDropDown,
                                            onChange: onChangeDetailsOrBillingPaneField
                                        }}
                                    />
                                </div>
                            </Col>
                            {showDigitalFax ?
                                <Col xs={6} md={6} className="pl-0">
                                    <div className="data-entry purpose-type">
                                        <Field
                                            name={BillingFormconstants.DIGITAL_FAX}
                                            component={ReduxFormTextField}
                                            props={{
                                                label: "Re-enter Fax Number",
                                                placeholder: "XXX-XXX-XXXX",
                                                maxLength: 12,
                                                suppressEnterSubmit: true,
                                                onBlur: onBlurDigitalFaxField,
                                                errorMessage
                                            }}
                                        />
                                    </div>
                                </Col> : null}
                        </Row>
                        <Row>
                            {props.featureFlags?.AutoCertification ? <Col xs={6} md={6} className="pl-0">
                                <div className="data-entry">
                                    <Field
                                        name={BillingFormconstants.CERTIFICATION_TEMPLATE}
                                        component={ReduxFormDropdownField}
                                        props={{
                                            label: "Certification Template",
                                            options: generatePickerOptions(props.certificationTypes, "name", "id"),
                                            onChange: onChangeDetailsOrBillingPaneField
                                        }}
                                    />
                                    <button type="button" disabled={disableRemoveCertification}
                                        onClick={() => onChangeDetailsOrBillingPaneField("", BillingFormconstants.CERTIFICATION_TEMPLATE)}
                                        style={{ marginLeft: "12px", marginBottom: "12px", marginTop: "12px", opacity: disableRemoveCertification ? 0.6 : 1.0 }}>
                                        <a>Remove Certification</a>
                                    </button>
                                </div>
                            </Col>
                                :
                                <Col xs={6} md={6}>
                                    <Field
                                        name={BillingFormconstants.CERTIFICATION_REQUESTED}
                                        component={ReduxFormcheckboxField}
                                        props={{
                                            fieldlabel: "Certification Requested?",
                                            checkboxLabel: 'Yes',
                                            defaultChecked: props.transactionDetails.certificationRequired,
                                            onChange: onChangeDetailsOrBillingPaneField
                                        }}
                                    />
                                </Col>}
                        </Row>
                        <Row className='delivery-instructions'>
                            <Col>
                                <div className="data-entry">
                                    <MultilineTextboxButtons
                                        text={values[BillingFormconstants.DELIVERY_INSTRUCTIONS]}
                                        label="Delivery Instructions:"
                                        maxLength={2000}
                                        className="deliveryInstructionsTextArea"
                                        onSave={e => {
                                            onBlurBillingPangeFields(e, BillingFormconstants.DELIVERY_INSTRUCTIONS);
                                            changeFieldValue(BillingFormconstants.DELIVERY_INSTRUCTIONS, e)
                                        }}
                                        saveRollover="Save Instructions"
                                        cancelRollover="Cancel"
                                    />
                                </div>
                            </Col>
                        </Row>
                        {getBillingTypeId() == 1 && <Row>
                            <Col>
                                <AccordionComponent data={billingAdditionalChargeValue} onBlur={onBlurBillingPangeFields}
                                    activeTabId={activeTabId} onCheckSameAsSendTo={onCheck}
                                    setAdditionalChargesErr={setAdditionalChargesErr}
                                    dispatch={props.dispatch}
                                    additionalChargesErr={props.formSyncErrors && props.formSyncErrors[BillingFormconstants.ADDITIONAL_CHARGES]} />
                            </Col>
                        </Row>}
                    </div> : null}

                {activeTabId === 4 ? <div>
                    <Row className="mb-5 rp-section mx-0">
                        <Col>
                            <div className="rp-title">Retrieval Protocol</div>
                            {props.retrieveProtocol && props.retrieveProtocol.map(data => (
                                <>
                                    <Col className="pl-0">
                                        <span>{data.description}</span>
                                    </Col>
                                    <div dangerouslySetInnerHTML={{ __html: data.protocolText.replaceAll && data.protocolText.replaceAll("<a", '<a target="_blank"') }} />
                                </>
                            ))}
                        </Col>
                    </Row>
                </div> : null}
            </div>
            {showCompleteTransactionPopUp &&
                <div>
                    <CompleteTransactionPopUp
                        setCompleteTransactionPopUp={setCompleteTransactionPopUp}
                        transactionID={props.transactionId}
                        completeTransaction={props.completeTransaction}
                        getNextTransactionId={props.getNextTransactionId!}
                        goToNextTransaction={goToNextTransaction}
                        facilityId={props.facilityId!}
                        organizationId={props.organizationId!}
                        onChangeDataEntryTab={props.onChangeDataEntryTab}
                        activeTabId={props.activeTabId}
                        setWait={setWait}
                        requestType={props.transactionDetails.requestPurpose!.id}
                        setCreateNewTransactionComplete={setCreateNewTransactionComplete}
                        createTransaction={createTransaction}
                        clearUserLocks={clearUserLocks}
                        isCreateTransaction={createNewTransactionComplete}
                        clearPreviousTransactionOnComplete={clearPreviousTransactionOnComplete}
                        requestContext={props.requestContext}
                        resetRequestContext={() => props.resetRequestContext && props.resetRequestContext()}
                        setCloseTranctionComplete={setCloseNewTransactionComplete}
                        closeTranctioncomplete={closeTransactionComplete}
                    />
                </div>
            }

            {showCompleteReviewPopUp &&
                <div>
                    <CompleteReviewPopUp
                        setShowCompleteReviewPopUp={setShowCompleteReviewPopUp}
                        transactionId={props.transactionId}
                        completeTransaction={props.completeTransaction}
                        returnToQueue={props.returnToQueue}
                        setWait={setWait}
                        clearPreviousTransactionOnComplete={clearPreviousTransactionOnComplete}
                        goToNextTransaction={goToNextQATransaction}
                        requestContext={props.requestContext}
                        onChangeDataEntryTab={props.onChangeDataEntryTab}
                        qaIssues={props.qaIssues}
                    />
                </div>
            }

            {showQAPDIssuePopUp &&
                <div>
                    <QAPDIssuePopUp
                        isOpen={showQAPDIssuePopUp}
                        handleClose={setShowQAPDIssuePopUp}
                        handleOk={props.returnToQueue}
                        goToNextTransaction={goToNextQATransaction}
                        transactionId={props.transactionId!}
                        transactionStatus={props.transactionStatus}
                        qaPDIssues={props.qaPDIssues}
                        setWait={setWait}
                        clearPreviousTransactionOnComplete={clearPreviousTransactionOnComplete}
                        onChangeDataEntryTab={props.onChangeDataEntryTab}
                    />
                </div>
            }

            {invalidatedFeeSchedules && <FeeScheduleInvalidated {...invalidatedFeeSchedules} />}

            <div className={`panel-footer text-center panel-footerRight ${activeTabId === 4 && 'records-footer'}`}>
                {
                    activeTabId === 1 || activeTabId === 3
                        ? (<span className="proceedCircle" onClick={onBtnClick}>
                            <span className="text-center proceed-link">
                                <ProceedIcon color={'#4d7f9d'} />
                                Proceed to {normalizedTabItems[updatedActiveTabId].label}
                            </span>
                        </span>)
                        :
                        activeTabId === 2 && requestType != DISCLOSURE_ACCOUNTING
                            ? (<span className="proceedCircle" onClick={onBtnClick}>
                                <span className="text-center proceed-link">
                                    <ProceedIcon color={'#4d7f9d'} />
                                    Proceed to {normalizedTabItems[updatedActiveTabId].label}
                                </span>
                            </span>)
                            :
                            ((props.transactionStatus?.id >= 130 && props.transactionStatus?.id <= 141 && props.transactionStatus?.id != 140) || props.transactionStatus?.id == 122 ? (
                                (props.requestContext == 6 || props.requestContext == 7 || props.requestContext == 8) ?
                                    (
                                        <div className='btn-group flex-wrap'>
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-primary" onClick={onCompleteTransaction}>
                                                    {props.transactionStatus?.id != 122 ? "Complete Review" : "Complete"}
                                                    <span className="caret"></span>
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    : (
                                        <div className='btn-group flex-wrap'>
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-primary" onClick={onCloseCompleteTransaction}>
                                                    Complete & Close
                                                    <span className="caret"></span>
                                                </button>
                                            </div>
                                        </div>
                                    )
                            ) : (
                                <div className='btn-group flex-wrap'>
                                    <div className="btn-group">
                                        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                                            Complete
                                            <span className="caret"></span>
                                        </button>

                                        <ul className="dropdown-menu" style={{ padding: "10px", whiteSpace: "nowrap" }}>
                                            <li><a href="#!" onClick={onCloseCompleteTransaction}>Complete & Close</a></li>
                                            <li><a href="#!" onClick={onCompleteTransaction}>Complete & Next</a></li>
                                            <li><a href="#!" onClick={onCompleteTransactionNewRequest}>Complete & New</a></li>
                                        </ul>
                                    </div>
                                </div>
                            ))
                }
            </div>
        </div>
    );
}

export function mapStateToProps(state: any, props: IpropType) {
    const formValues = state.form && state.form[FormConstants.DATA_ENTRY_FIELDS_FORM] ?
        state.form[FormConstants.DATA_ENTRY_FIELDS_FORM].values : {}
    const patientDetails = state.dataEntryState.patientDetailsAttributes
    const transactionDetails = props.transactionDetails
    const selectedPHICodes = props.selectedPHICodes || []
    const additionalChargeRecords = props.additionalChargeRecords || {}
    const requestorDetails: Requestor | undefined = state.dataEntryState.requestorDetails;
    const requestorBillingDetails = state.dataEntryState.requestorBillingDetails

    const onChangeSensitiveInfo = () => {
        let disclosureChanged = formValues && (!state.landingPageState.isNewTransaction || formValues[FormConstants.DISCLOSURE_CHANGED]);

        const requestSensitiveData = state.dataEntryState.transactionDetails.sensitiveInfo;
        const sensitiveInfo = state.form.DATA_ENTRY_FIELDS_FORM.sensitiveInfo;

        let obj = {};
        let isSelectAllValues: any = null;
        let isSelectNoValues: any = null;
        if (requestSensitiveData && sensitiveInfo && (disclosureChanged || sensitiveInfo.some(d => d) || requestSensitiveData.some(d => d.stateID === 1))) {


            requestSensitiveData.forEach(el => {
                obj = { ...obj, [el.name]: el.stateID === 1 ? { recordType: el.name } : null }
            })
            isSelectAllValues = Object.keys(sensitiveInfo).every(i => i != null);
            isSelectNoValues = Object.keys(sensitiveInfo).every(i => i == null);
            disclosureChanged = true;
        }
        return { isSelectAllValues, isSelectNoValues, sensitiveInfo: obj, disclosureChanged }
    }

    const onChangePHIcodes = () => {
        let obj = {};
        if (selectedPHICodes) {
            selectedPHICodes.map(PHIData => {
                if (PHIData.isRetrieved) {
                    obj = { ...obj, [PHIData.requestedItemID]: { code: PHIData.code, description: PHIData.description } }

                }
                return null
            })
        }

        return obj
    }

    const { isSelectAllValues, isSelectNoValues, disclosureChanged } = onChangeSensitiveInfo()

    return {
        formState: state.form && state.form[FormConstants.DATA_ENTRY_FIELDS_FORM],
        transactionId: state.landingPageState.transactionId,
        initialValues: {
            ...formValues,
            [FormConstants.REQUEST_TYPE]: transactionDetails.requestPurpose?.typeID ?? 0,
            [FormConstants.PURPOSE_TYPE]: transactionDetails.requestPurpose?.id ?? 0,
            [FormConstants.PATIENT_NAME]: patientDetails.contact?.firstName,
            [FormConstants.PATIENT_LAST_NAME]: patientDetails.contact?.lastName,
            [FormConstants.PATIENT_MIDDLE_NAME]: patientDetails?.contact?.middleInitial ? patientDetails?.contact?.middleInitial
                : (patientDetails?.contact?.middleName.length ? patientDetails?.contact?.middleName?.charAt(0).toUpperCase() : ''),
            [FormConstants.DOB]: patientDetails.dob ? new Date(patientDetails.dob) : null,
            [FormConstants.EMPI_NUMBER]: patientDetails?.empi?.toString(),
            [FormConstants.MRN_ID]: (patientDetails.mrn === "" ? null : patientDetails.mrn) || (transactionDetails.mrn === "" ? null : transactionDetails.mrn),
            [FormConstants.AUTHORIZATION_DATE]: transactionDetails.date?.authorization ? transactionDetails.date.authorization : null,
            [FormConstants.REQUEST_DATE]: transactionDetails.date?.request ? transactionDetails.date.request : null,
            [FormConstants.RECEIVED_DATE]: transactionDetails.date?.received ? transactionDetails.date.received : null,
            [FormConstants.DUE_DATE]: transactionDetails.date?.due ? transactionDetails.date.due : null,
            [FormConstants.REQUEST_ID]: transactionDetails.requestID,
            [FormConstants.CASE_NUMBER]: transactionDetails.caseNumber,
            [FormConstants.CLINIC_RESPONISBLE]: transactionDetails.disclosingInstitution?.id?.toString(),
            [FormConstants.SITE_CODE]: '',
            [FormConstants.SEARCH_LAST_NAME]: '',
            [FormConstants.SEARCH_DOB]: '',
            [RequestorFormConstants.PHONE_FAX_NUMBER]: "",
            [RequestorFormConstants.EMAIL_ADDRESS]: "",
            [RequestorFormConstants.EMAIL]: requestorDetails?.requestorInfo?.email,
            [RequestorFormConstants.FAX_NUMBER]: requestorDetails?.requestorInfo?.fax,
            [RequestorFormConstants.REQUESTOR_NAME]: requestorDetails?.fullName,
            [RequestorFormConstants.ADDRESS]: requestorDetails?.requestorAddress?.address1,
            [RequestorFormConstants.ADDRESS2]: requestorDetails?.requestorAddress?.address2,
            [RequestorFormConstants.CITY]: requestorDetails?.requestorAddress?.city,
            [RequestorFormConstants.STATE]: requestorDetails?.requestorAddress?.state,
            [RequestorFormConstants.ZIP]: requestorDetails?.requestorAddress?.zipCode,
            [RequestorFormConstants.FIRST_NAME]: requestorDetails?.requestorInfo?.firstName,
            [RequestorFormConstants.LAST_NAME]: requestorDetails?.requestorInfo?.lastName,
            [RequestorFormConstants.PHONE_NUMBER]: requestorDetails?.requestorInfo?.phone,
            [RequestorFormConstants.INTENRNAL_REQUESTOR]: "",
            [FormConstants.DISCLOSURE_REASON]: transactionDetails.disclosure?.disclosureReasonID,
            [FormConstants.DISCLOSURE_DATE]: transactionDetails.disclosure?.disclosureDate,
            [FormConstants.PAGES_DISCLOSED]: transactionDetails.disclosure?.numberOfPage,
            [FormConstants.PROTOCOL_NAME]: transactionDetails.disclosure?.protocolName,
            [FormConstants.PROTOCOL_NUMBER]: transactionDetails.disclosure?.protocolnumber,
            [FormConstants.SPECIAL_NOTES]: transactionDetails.disclosure?.specialNote,
            [FormConstants.PHI]: onChangePHIcodes(),
            [FormConstants.DISCLOSE_ALL_INFO]: isSelectAllValues,
            [FormConstants.DONT_DISCLOSE_ANY_INFO]: isSelectNoValues,
            [FormConstants.DISCLOSURE_CHANGED]: disclosureChanged,
            [FormConstants.GENETIC_INFORMATION]: '',
            [FormConstants.HIV]: '',
            [FormConstants.MENTAL_HEALTH]: '',
            [FormConstants.SUBSTANCE_ABUSE]: '',
            [FormConstants.STD]: '',
            [FormConstants.AUDIT_TYPE]: transactionDetails.requestForAuditType,
            [FormConstants.ON_BEHALF_OF]: transactionDetails.onBehalfOf,
            [BillingFormconstants.DELIVERY_INSTRUCTIONS]: transactionDetails.deliveryInstructions,
            [BillingFormconstants.ADDITIONAL_CHARGES]: additionalChargeRecords,
            [BillingFormconstants.BILLING_TYPES]: transactionDetails.billingTypeID,
            [BillingFormconstants.RELEASE_METHODS]: transactionDetails.releaseMethod?.id,
            [BillingFormconstants.SHIPPING_SERVICES]: transactionDetails.shippingService,
            [BillingFormconstants.AUXILIARY_CHARGE]: transactionDetails.includeAuxilliaryPages,
            [BillingFormconstants.CERTIFICATION_REQUESTED]: transactionDetails.certificationRequired,
            [BillingFormconstants.CERTIFICATION_TEMPLATE]: transactionDetails.certificationTypeId,
            [BillingFormconstants.REQUIRES_PREPAYMENT]: requestorDetails?.prePay,
            [BillingFormconstants.CHARGE_FOR_POSTAGE]: transactionDetails.postageIsApplied,
            [BillingFormconstants.RELEASE_METHOD_CHARGE]: transactionDetails.includeRequestPages,
            [BillingFormconstants.SEND_TO_REQUESTOR_NAME]: requestorDetails?.fullName,
            [BillingFormconstants.SEND_TO_FIRST_NAME]: requestorDetails?.requestorInfo?.firstName,
            [BillingFormconstants.SEND_TO_LAST_NAME]: requestorDetails?.requestorInfo?.lastName,
            [BillingFormconstants.SEND_TO_ADDRESS_LINE1]: requestorDetails?.requestorAddress?.address1,
            [BillingFormconstants.SEND_TO_ADDRESS_LINE2]: requestorDetails?.requestorAddress?.address2,
            [BillingFormconstants.SEND_TO_CITY]: requestorDetails?.requestorAddress?.city,
            [BillingFormconstants.SEND_TO_STATE]: requestorDetails?.requestorAddress?.state,
            [BillingFormconstants.SEND_TO_EMAIL_ADDRESS]: requestorDetails?.requestorInfo?.email,
            [BillingFormconstants.SEND_TO_ZIP]: requestorDetails?.requestorAddress?.zipCode,
            [BillingFormconstants.SEND_TO_PHONE]: requestorDetails?.requestorInfo?.phone,
            [BillingFormconstants.SEND_TO_FAX]: requestorDetails?.requestorInfo?.fax,
            [BillingFormconstants.SAME_AS_SEND_TO]: false,
            [BillingFormconstants.BILL_TO_REQUESTOR_NAME]: requestorBillingDetails?.requestorBillingLocation,
            [BillingFormconstants.BILL_TO_FIRST_NAME]: requestorBillingDetails?.firstName,
            [BillingFormconstants.BILL_TO_LAST_NAME]: requestorBillingDetails?.lastName,
            [BillingFormconstants.BILL_TO_ADDRESS_LINE1]: requestorBillingDetails?.address?.address1,
            [BillingFormconstants.BILL_TO_ADDRESS_LINE2]: requestorBillingDetails?.address?.address2,
            [BillingFormconstants.BILL_TO_CITY]: requestorBillingDetails?.address?.city,
            [BillingFormconstants.BILL_TO_STATE]: requestorBillingDetails?.address?.state,
            [BillingFormconstants.BILL_TO_EMAIL_ADDRESS]: requestorBillingDetails?.email,
            [BillingFormconstants.BILL_TO_ZIP]: requestorBillingDetails?.address?.zipCode,
            [BillingFormconstants.BILL_TO_PHONE]: requestorBillingDetails?.phone,
            [BillingFormconstants.BILL_TO_FAX]: requestorBillingDetails?.fax,
            [BillingFormconstants.REQUIRES_PREPAYMENT]: requestorBillingDetails?.prePay,
            [BillingFormconstants.DIGITAL_FAX]: state.dataEntryState.confirmFax,
            //dds fields
            [RequestorFormConstants.RQID]: transactionDetails.transactionDds?.rqid,
            [RequestorFormConstants.RQ_SITE_CODE]: transactionDetails.transactionDds?.txSiteCode,
            [RequestorFormConstants.TX_SITE_CODE]: transactionDetails.transactionDds?.txSiteCode,
            [RequestorFormConstants.DOC_RETURN_CODE]: transactionDetails.transactionDds?.docReturnCode,
            [RequestorFormConstants.DOC_TYPE]: transactionDetails.transactionDds?.docType,
            [RequestorFormConstants.SSN]: transactionDetails.transactionDds?.ssn,
            [RequestorFormConstants.NO_BARCODE]: transactionDetails.transactionDds?.noBarcode,
            [RequestorFormConstants.ROUTING_FIELD]: transactionDetails.transactionDds?.routingField,
            [FormConstants.ESCALATION]: transactionDetails.isEscalated
        },
        requestTypes: state.dataEntryState.requestTypes,
        discloseInstitutions: state.dataEntryState.discloseInstitutions,
        selectedPHICodes: state.dataEntryState.selectedPHICodes,
        additionalChargeRecords,
        requestorContactDetails: state.dataEntryState.requestorContactDetails,
        feeSchedules: state.dataEntryState.feeSchedules,
        releaseMethods: state.dataEntryState.releaseMethod,
        shippingServices: state.dataEntryState.shippingService,
        requestorSearchDetails: state.dataEntryState.requestorSearchDetails,
        globalUser: state.loginState.userID,
        patientSearchDetails: state.dataEntryState.patientSearchDetails,
        phiCodes: state.dataEntryState.phiCodes,
        formSyncErrors: state.dataEntryState.formSyncErrors,
        getRequestorSearchDetailsAPIStatus: state.dataEntryState.getRequestorSearchDetailsAPIStatus,
        getPatientSearchResultsAPIStatus: state.dataEntryState.getPatientSearchResultsAPIStatus,
        getContactSearchDetailsAPIStatus: state.dataEntryState.getContactSearchDetailsAPIStatus,
        facilityId: state.landingPageState.selectedFacilityDetails?.facility.id,
        // AC15: use the existing transactionDetails prop instead of re-reading
        // state.dataEntryState.transactionDetails directly a second time.
        organizationId: transactionDetails?.facility?.id,
        canEditPatient: state.dataEntryState.patientDetailsAttributes?.canEdit,
        updatedPatientDetailsAttributes: Object.keys(state.dataEntryState.rightPaneUpdatedPatientDetailsAttributes).length ?
            state.dataEntryState.rightPaneUpdatedPatientDetailsAttributes :
            {
                transactionId: props.transactionId,
                [FormConstants.PATIENT_NAME]: patientDetails.contact?.firstName,
                [FormConstants.PATIENT_MIDDLE_NAME]: patientDetails?.contact?.middleInitial ? patientDetails?.contact?.middleInitial
                    : (patientDetails?.contact?.middleName.length ? patientDetails?.contact?.middleName?.charAt(0).toUpperCase() : ''),
                [FormConstants.PATIENT_LAST_NAME]: patientDetails.contact?.lastName,
                [FormConstants.DOB]: patientDetails.dob ? new Date(patientDetails.dob) : null,
                [FormConstants.EMPI_NUMBER]: patientDetails?.empi || '',
                [FormConstants.MRN_ID]: patientDetails.mrn,
                patientDataid: props.transactionDetails?.patient?.id
            },
        patientDetailsUpdated: state.dataEntryState.patientDetailsUpdated,
        auditTypes: state.dataEntryState.auditTypes,
        onBehalfOf: state.dataEntryState.onBehalfOf,
        requestorDetails: requestorDetails,
        lastUsedRequestorContact: state.dataEntryState.lastUsedRequestorInfo,
        validationPassed: state.dataEntryState.getValidation == API_SUCCESS,
        transactionDDS: state.dataEntryState.readBarCodeDDS,
        documentsList: state.dataEntryState.documentsList,
        intiaTxlSagaCallCount: state.dataEntryState.intiaTxlSagaCallCount,
        isNewTransaction: state.landingPageState.isNewTransaction,
        facilityAdditionalFields: state.dataEntryState.FacilityAdditionalFields,
        requestContext: state.landingPageState.requestContext,
        updateDeliveryInstructionsStatus: state.dataEntryState.updateDeliveryInstructionsStatus,
        transactionStatus: state.dataEntryState.leftPaneTransactionDetails?.transactionStatus,
        readBarCodeDDSAPIStatus: state.dataEntryState.readBarCodeDDSAPIStatus,
        requestorComplete: state.dataEntryState.requestorComplete,
        getQAPDIssues: state.dataEntryState.getQAPDIssues,
        qaPDIssues: state.dataEntryState.qaPDIssues,
        qaIssues: state.dataEntryState.getQAIssues,
        certificationTypes: state.dataEntryState.certificationTypes,
        certificationTypeId: state.dataEntryState.transactionDetails?.certificationTypeId,
        featureFlags: state.loginState.featureFlags,
        updateRequestPurposeStatus: state.dataEntryState.updateRequestPurposeStatus,
    }
}

export function mapDispatchToProps(dispatch: (data: { type: string }) => void, props: IpropType) {
    return {
        createSendToContact: (contact: NewSendToContact) => dispatch(createSendToContactActionCreator(contact)),
        updateSendToContact: (organizationId: number, requestBufferId: number, contact: Contact) => dispatch(updateSendToContactActionCreator(organizationId, requestBufferId, contact)),
        setSendToContact: (contact?: Contact) => dispatch(setSendToContactActionCreator(contact)),
        updateBillToRequestorData: (data: any) =>
            dispatch(updateBillToRequestorDetailsRequest(data)),
        patchSendToRequestorContactData: (requestData: sendToRequestorDataProps) => (
            dispatch(patchSendToRequestorContactActionCreators(requestData))),
        getRequestorSearchDetailsActionCreator: (data: any, organizationId: number, globalUserId: number) => (
            dispatch(getRequestorSearchDetailsActionCreator(data, organizationId, globalUserId))),
        getPatientListSearchDetails: (facilityId: number, lastName: string, dob: any) => (
            dispatch(getPatientSearchDetailsActionCreator(facilityId, lastName, dob))),
        updateBillingPaneFields: (data: any, updateData?: boolean) =>
            dispatch(updateBillingPaneFields(data, updateData)),
        createPatientRecordRequest: (data: any, onSuccess) =>
            dispatch(createPatientRecordRequest(data, onSuccess)),
        updateFormSyncErrors: (data: any) => dispatch(updateFormSyncErrorsActionCreator(data)),
        updateDisclosureInformationDetails: (data: any) => dispatch(updateDisclosureInformationActionCreator(data)),
        completeTransaction: (data: any) => dispatch(completeTransactionTaskActionCreator(data)),
        returnToQueue: (data: any) => dispatch(returnToQueueTaskActionCreator(data)),
        getQAPDIssues: (transactionId: string) => dispatch(getQAPDIssuesActionCreator(transactionId)),
        getBillToRequestorDetails: (data: any) => dispatch(billToRequestorDetailsActionCreator(data)),
        createPatientRecordSuccess: (data: any) => dispatch(createPatientRecordSuccess(data)),
        getNextTransactionId: (facilityId: number, context: number) =>
            dispatch(nextTransactionIdActionCreator(facilityId, context)),
        patchRequestorComplete: (data: string) => dispatch(requestorCompleteActionCreator(data)),
        patchBillingComplete: (data: string) => dispatch(billingCompleteActionCreator(data)),
        patchDetailsComplete: (data: string) => dispatch(detailsCompleteActionCreator(data)),
        patchPatientDetailsCreator: (data: any) => dispatch(patchPatientDetailsCreator(data)),
        getAuditTypesRequest: (data: any) => dispatch(getAuditTypesRequest(data)),
        getOBOsRequest: (data: any) => dispatch(getOBOsRequest(data)),
        checkValidation: (data: any) => dispatch(getValidateRequest(data)),
        setLastUsedRequestorInfo: (data: any) => dispatch(setLastUsedRequestorInfo(data)),
        checkDuplicates: (transactionId: string, caseNumber: string) => dispatch(checkDuplicateTransactions(transactionId, caseNumber)),
        createTransaction: (data: { facilityId: number }) => dispatch(createTransaction(data)),
        clearUserLocks: () => dispatch(clearUserLocksActionRequest()),
        clearPreviousTransactionOnComplete: () => dispatch(clearPreviousTransactionOnCompleteCreator()),
        readBarCodeDDSRequest: (documentId: string) => dispatch(readBarCodeDDSRequest(documentId)),
        updateRequestorDetails: (data?: Requestor) => dispatch(setRequestorDetailsActionCreator(data)),
        saveInformationToRelease: (data: ReleaseInfoUpdate) => dispatch(updateInformationToReleaseActionCreator(data)),
        saveAndUpdateSensitiveInfo: (data: SensitiveInfoUpdateAPI) => dispatch(updateSensitiveInfoActionCreator(data)),
        resetRequestContext: () => dispatch(resetRequestContext()),
        getTransactionAttributes: (transactionId: string) =>
            dispatch(getTransactionAttributesActionCreator(transactionId)),
        putDigitalFaxValidation: (transactionId: string, faxNumber: any) => dispatch(putDigitalFaxValidationCreator(transactionId, faxNumber)),
        putAuditTransactionSensitiveInfo: (transactionId: string, recordContains: any) => dispatch(putAuditTransactionSensitiveInfoCreator(transactionId, recordContains)),
        resetRequestorContactList: () => dispatch(resetRequestorContactList()),
        getFacilityReleaseMethods: (facilityId: number, transactionId: string) => dispatch(getReleaseMethodOptionsData(facilityId, transactionId)),
        setConfirmFaxNumberAction: (faxNumber: string) => dispatch(setConfirmFaxNumberAction(faxNumber)),
        getNextQATransactionCall: () => dispatch(getNextQATransaction(null)),
        lateValidationCall: (results: string) => dispatch(lateValidation(results)),
        setCertificationTemplate: (transactionId: string, certificationType: string) => dispatch(setCertificationTemplateAction(transactionId, certificationType)),
    };
}

const DataEntryDetailsReduxForm = reduxForm<{}, IpropType>({
    form: FormConstants.DATA_ENTRY_FIELDS_FORM,
    validate: localValidations,
    onSubmit: submitValidations,
    touchOnChange: true,
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true
})(DataEntryDetailsRightPane)

export default connect<{}, {}, IpropType>(mapStateToProps, mapDispatchToProps)(
    DataEntryDetailsReduxForm
)
